import React, { useState, useEffect, useContext, Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { firebaseAuth } from "../../../providers/AuthProvider";
import firebase from "firebase/compat/app";
import "firebase/storage";
import { db } from "../../../firebase";
import "firebase/functions";
import { DeleteIcon, DLAbbrDesMap, GetDeviceId } from "../../../Constants";
import "../../../assets/css/groups.css";
import { toast } from "react-toastify";
import SignatureCanvas from "react-signature-canvas";
import "../../../assets/css/registrations.css";
import "../../../assets/css/register.css";
import DOMPurify from "dompurify";
import { createWaiverPdf } from "../../../utils/waiverPdf";
import { loadDealerOptions, filterDealerOption } from "../../../utils/dealerOptions";
import BarcodeReader from "react-barcode-reader";
import moment from "moment";
// import * as Sentry from "@sentry/react";
import Dropzone from 'react-dropzone';
import Moment, { relativeTimeRounding } from 'moment';
import { StatesList } from "../../../Constants";
import { AdyenCheckout, CustomCard } from '@adyen/adyen-web';
import { withAdyenCountryCode } from '../../../utils/adyenConfiguration';
import { isCrmDataFieldRequired } from '../../../utils/crmDataFields';
import { shouldAskDealerOptIn } from '../../../utils/dealerOptIn';
import { getVisibleModelInterestOptions } from '../../../utils/modelInterest';
import { useModelInterestCatalog } from '../../../hooks/useModelInterestCatalog';
import '@adyen/adyen-web/styles/adyen.css';
import { edit } from "@cloudinary/url-gen/actions/animated";
import Select from 'react-select';
import { CurrentEventDataContext } from "../CurrentEventDataContext";
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { geocodeByPlaceId } from 'react-google-places-autocomplete';
import { getSignatureDataUrl } from "../../../utils/signatureCanvas";
import {
  AdditionalFieldHtml,
  AdditionalFieldLabel,
} from "../../AdditionalFieldHtml";
import { TestPaymentModeBanner } from "../../TestPaymentModeBanner";
import {
  actionKey,
  RegistrationCheckInPanel,
} from "../../checkin/RegistrationCheckInPanel";
import {
  getCommerceItems,
  getCommerceItemSelectableMax,
} from "../../../utils/ticketConfiguration";
import LoadingIndicator from "../../common/LoadingIndicator";
import { RegistrationNotes, RegistrationEmailHistory } from "./RegistrationActivity";
// import { event } from "firebase-functions/v1/analytics";

const getRegistrationStatusLabel = (registration, fallbackStatus) => {
  const status = fallbackStatus || registration?.status;

  if (!status) return "Not set";
  if (status === "Registered" && registration?.isConfirmed) return "Confirmed";
  if (status === "Cancelled" && registration?.isNoShow) return "No Show-Cancelled";
  if (status === "Cancelled" && registration?.isConfirmed) return "Self-Cancelled";

  return status;
};

const getRegistrationStatusSelectValue = (registration) => {
  if (registration?.status === "Registered" && registration?.isConfirmed) return "Confirmed";
  if (registration?.status === "Cancelled" && registration?.isNoShow) return "No Show-Cancelled";
  if (registration?.status === "Cancelled" && registration?.isConfirmed) return "Self-Cancelled";

  return registration?.status || "";
};

const getRegistrationStatusUpdate = (status) => {
  if (status === "Confirmed") {
    return { status: "Registered", isConfirmed: true, isNoShow: false };
  }
  if (status === "Self-Cancelled") {
    return { status: "Cancelled", isConfirmed: true, isNoShow: false };
  }
  if (status === "No Show-Cancelled") {
    return { status: "Cancelled", isNoShow: true };
  }
  if (status === "Registered") {
    return { status, isConfirmed: false, isNoShow: false };
  }
  if (status === "Cancelled") {
    return { status, isConfirmed: false, isNoShow: false };
  }

  return { status, isConfirmed: false, isNoShow: false };
};

const Registration = () => {
  const [addressLookup, setAddressLookup] = useState(null);

  const { id, eventId } = useParams();
  const storage = firebase.storage().ref();
  const history = useNavigate();
  const { user } = useContext(firebaseAuth);
  const [eventData, setEventData] = useState(null);
  const modelInterestCatalog = useModelInterestCatalog();
  const { currentEventData, setCurrentEventData } = useContext(CurrentEventDataContext);
  const [dealersSelected, setDealersSelected] = useState(
    eventData?.dealersSelected
  );
  const [disabledSend, setDisabledSend] = useState(false);
  const [uploadInfo, setUploadInfo] = useState(null);
  const [fileUpload, setFileUpload] = useState([]);
  const [adyenLoaded, setAdyenLoaded] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [savingSignature, setSavingSignature] = useState(false);
  const [sendEmailCheck, setSendEmailCheck] = useState(false);
  const sigCanvas = React.createRef();
  const sigGuestCanvas = React.createRef();
  const [editRegistration, setEditRegistration] = useState(null);
  const [completeWaiver, setCompleteWaiver] = useState(false);
  const [completeGuestWaiver, setCompleteGuestWaiver] = useState(false);
  const [previewEmailHtml, setPreviewEmailHtml] = useState(null);
  const [waiverUrl, setWaiverUrl] = useState();
  const [waiverSigUrl, setWaiverSigUrl] = useState();
  const [waiverGuestUrl, setWaiverGuestUrl] = useState();
  const [waiverGuestSigUrl, setWaiverGuestSigUrl] = useState();
  const [itemSelection, setItemSelection] = useState({ itemId: null });
  const [userPasscodes, setUserPasscodes] = useState([]);
  const [sessionsLoaded, setSessionsLoaded] = useState(false);
  const [commerceAvailability, setCommerceAvailability] = useState({
    error: null,
    eventSoldCount: 0,
    isLoaded: false,
    originalRegistration: null,
    soldCounts: {},
  });
  const [checkInData, setCheckInData] = useState(null);
  const [checkInBusyActionKey, setCheckInBusyActionKey] = useState(null);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [initialLoadError, setInitialLoadError] = useState(null);
  const [savingRegistration, setSavingRegistration] = useState(false);
  const [activityRefreshKey, setActivityRefreshKey] = useState(0);
  const [activitySavedId, setActivitySavedId] = useState(null);
  const [checkInLoadedRegistrationId, setCheckInLoadedRegistrationId] =
    useState(null);
  var parseDriverLicense = (txt) => {
    let lines = txt.split("\n");
    let abbrs = Object.keys(DLAbbrDesMap);
    let map = {};
    lines.forEach((line, i) => {
      let abbr;
      let content;
      if (i === 0) {
        abbr = "DAQ";
        content = line.substring(line.indexOf(abbr) + 3);
      } else {
        abbr = line.substring(0, 3);
        content = line.substring(3).trim();
      }
      if (abbrs.includes(abbr)) {
        map[abbr] = {
          description: DLAbbrDesMap[abbr],
          content: content,
        };
      }
    });
    return map;
  };
  const arraySearch = (array, keyword) => {
    const searchTerm = keyword.toLowerCase();
    if (array.length === 0)
      return false;
    let arrayIndex = array.findIndex(value => value && value.fieldType?.toLowerCase() === searchTerm);
    return arrayIndex;
  }
  const handleScan = (d) => {
    // console.log(d.indexOf("porsche-ezentrum"));
    if (d.indexOf("porsche-ezentrum") >= 0) {
      let d_arr = d.split("/");
      let regId = d_arr[d_arr.length - 1];
      // console.log(regId);
      history("/manage/registration/" + regId);
      history.go();
    } else {
      if (d.indexOf("ANSI") < 0) return;
      let dlData = parseDriverLicense(d);
      if (editRegistration) {
        let tmpReg = editRegistration;
        tmpReg.firstName = dlData["DAC"]?.content;
        tmpReg.lastName = dlData["DCS"]?.content;
        tmpReg.address1 = dlData["DAG"]?.content;
        tmpReg.city = dlData["DAI"]?.content;
        tmpReg.state = dlData["DAJ"]?.content;
        tmpReg.postal = dlData["DAK"]?.content?.substring(0, 5);
        setEditRegistration({
          ...editRegistration,
          firstName: tmpReg.firstName,
          lastName: tmpReg.lastName,
          address1: tmpReg.address1,
          city: tmpReg.city,
          state: tmpReg.state,
          postal: tmpReg.postal,
        });
        window.scrollTo(0, 0);
      }
    }
  };
  const handleScanError = (e) => {
    console.log(e);
  };
  const clearCanvas = () => { sigCanvas.current.clear(); setWaiverSigUrl(null) }
  const clearGuestCanvas = () => { sigGuestCanvas.current.clear(); setWaiverGuestSigUrl(null) }

  const [scr, setScr] = useState({
    width: window.innerWidth > 600 ? 600 : window.innerWidth - 30,
    height: window.innerWidth > 600 ? 240 : window.innerWidth * 0.4 - 30,
  });
  const sendWaiverSMS = () => {
    if (editRegistration.phone && editRegistration.firstName && editRegistration.lastName) {
      var sendWSMS = firebase
        .functions()
        .httpsCallable("appV2/sendWaiverSMS");
      sendWSMS({ reg: editRegistration, eventData: eventData, toPhone: editRegistration.phone, isGuest: false })
        .then((result) => {
          if (result?.data.error) {
            toast.warning(result?.data.message);
            return;
          }
          toast.success("Waiver sms sent to user.");
        })
        .catch((e) => {
          // Sentry.captureException(e);
          toast.error(e.message);
        });
    } else {
      toast.warning("Phone and name information is required to send confirmation sms.");
    }
  };
  const sendGuestWaiverSMS = () => {

    if (editRegistration.firstName && editRegistration.lastName && editRegistration.guestPhone && editRegistration.guestFirstName && editRegistration.guestLastName) {
      var sendEmail = firebase
        .functions()
        .httpsCallable("appV2/sendWaiverSMS");
      sendEmail({ reg: editRegistration, eventData: eventData, toPhone: editRegistration.guestPhone, isGuest: true })
        .then((result) => {
          if (result?.data.error) {
            toast.warning(result?.data.message);
            return;
          }
          toast.success("Waiver sms sent to guest.");
        })
        .catch((e) => {
          // Sentry.captureException(e);
          toast.error(e.message);
        });
    } else {
      toast.warning("Guest phone and all name information is required to send confirmation sms.");
    }
  };
  const sendWaiver = () => {
    if (editRegistration.email && editRegistration.firstName && editRegistration.lastName) {
      var sendEmail = firebase
        .functions()
        .httpsCallable("appV2/sendWaiverEmail");
      sendEmail({ reg: editRegistration, eventData: eventData, toEmail: editRegistration.email, isGuest: false })
        .then((result) => {
          if (result?.data.error) {
            toast.warning(result?.data.message);
            return;
          }
          toast.success("Waiver email sent to user.");
        })
        .catch((e) => {
          // Sentry.captureException(e);
          toast.error(e.message);
        });
    } else {
      toast.warning("Email and name information is required to send confirmation email.");
    }
  };
  const sendGuestWaiver = () => {

    if (editRegistration.firstName && editRegistration.lastName && editRegistration.guestEmail && editRegistration.guestFirstName && editRegistration.guestLastName) {
      var sendEmail = firebase
        .functions()
        .httpsCallable("appV2/sendWaiverEmail");
      sendEmail({ reg: editRegistration, eventData: eventData, toEmail: editRegistration.guestEmail, isGuest: true })
        .then((result) => {
          if (result?.data.error) {
            toast.warning(result?.data.message);
            return;
          }
          toast.success("Waiver email sent to guest.");
        })
        .catch((e) => {
          // Sentry.captureException(e);
          toast.error(e.message);
        });
    } else {
      toast.warning("Guest Email and all name information is required to send confirmation email.");
    }
  };
  const deleteWaiver = () => {
    // setEditRegistration({ ...editRegistration, waiver: null,waiverSignature:null });
    setWaiverUrl(null);
    setWaiverSigUrl(null);
    sigCanvas.current.clear();
    deleteFile("/waivers/", editRegistration.id + ".pdf");
    deleteFile("/waivers/", editRegistration.id + ".jpg");
    let reg = editRegistration;
    reg.hasWaiver = false;
    saveRegistration(reg, "none");
    setCompleteWaiver(false);
  };
  const deleteGuestWaiver = () => {
    // setEditRegistration({ ...editRegistration, waiver: null,waiverSignature:null });
    setWaiverGuestUrl(null);
    setWaiverGuestSigUrl(null);
    sigCanvas.current.clear();
    deleteFile("/guest_waivers/", editRegistration.id + ".pdf");
    deleteFile("/guest_waivers/", editRegistration.id + ".jpg");
    let reg = editRegistration;
    reg.hasGuestWaiver = false;
    saveRegistration(reg, "none");
    setCompleteGuestWaiver(false);
  };
  const deleteFile = (pathToFile, fileName) => {
    const ref = firebase.storage().ref(pathToFile);
    const childRef = ref.child(fileName);
    // console.log(childRef);
    if (childRef) {
      childRef.delete().catch((error) => {
        console.log(error);
      });
    }
  };
  const saveCanvas = async () => {
    if (!sigCanvas.current || sigCanvas.current.isEmpty()) {
      setSavingSignature(false);
      return;
    }

    try {
      const upload = await storage
        .child("/waivers/" + editRegistration.id + ".jpg")
        .putString(getSignatureDataUrl(sigCanvas.current), "data_url");
      const url = await upload.ref.getDownloadURL();
      setWaiverSigUrl(url);
    } catch (error) {
      console.error("Unable to save waiver signature.", error);
      toast.error("There was an error saving the waiver signature.");
    } finally {
      setSavingSignature(false);
    }
  };
  const saveGuestCanvas = async () => {
    if (!sigGuestCanvas.current || sigGuestCanvas.current.isEmpty()) {
      setSavingSignature(false);
      return;
    }

    try {
      const upload = await storage
        .child("/guest_waivers/" + editRegistration.id + ".jpg")
        .putString(getSignatureDataUrl(sigGuestCanvas.current), "data_url");
      const url = await upload.ref.getDownloadURL();
      setWaiverGuestSigUrl(url);
    } catch (error) {
      console.error("Unable to save guest waiver signature.", error);
      toast.error("There was an error saving the guest waiver signature.");
    } finally {
      setSavingSignature(false);
    }
  };
  const newReg = (eData) => {
    let tmpId = db.collection("registrations").doc().id;
        setEditRegistration({
      dealer: eData?.dealersSelected && eData?.dealersSelected.length === 1 ? eData?.dealersSelected[0].code : null,
      status: eData?.defaultRegStatus
        ? eData?.defaultRegStatus
        : "Registered",
      eventId: eData?.id,
      id: tmpId,
    });
  }
  const guestReg = (id, parentId) => {
    setEditRegistration({
      status: eventData?.defaultRegStatus
        ? eventData?.defaultRegStatus
        : "Registered",
      isGuest: true,
      parentId: parentId,
      eventId: eventData?.id,
      id: id,
    });
  }
  const onDrop = async (acceptedFiles, rejectedFiles) => {
    if (eventData?.allowUpload && acceptedFiles.length > 0) {
      await acceptedFiles.map(async (f, index) => {
        firebase.storage()
          .ref("/submissions/" + editRegistration.id + "/" + f.path)
          .put(f).then(() => {
            updateUploads();
          });
      });
    }
    let x = rejectedFiles?.forEach((item) => {
      if (item.file?.name && item.errors[0].message)
        alert(item.file?.name + ":\n" +
          item.errors[0].message + "\n\n");
    });
  }
  const updateUploads = async (allowUpload) => {
    if (eventData?.allowUpload || allowUpload) {
      console.log('updateUploads');
      var storageRef = firebase.storage().ref("/submissions/" + id + "/");
      let tmpFiles = [];
      let i = 0;
      storageRef.listAll()
        .then(function (result) {
          result.items.forEach(function (fileRef) {
            fileRef.getDownloadURL().then(function (url) {
              tmpFiles.push({ name: fileRef.name, url: url });
              i++;
              if (i == result.items.length)
                setUploadInfo(tmpFiles);
            }).catch(function (error) {
              // Handle any errors
            });
          });
        }).catch(function (error) {
          // Handle any errors
        });
    }
  }
  const handleOnChange = (state, component) => {
    // console.log(state.isValid);
    // console.log(state.data);
    // state.isValid // True or false. Specifies if all the information that the shopper provided is valid.
    // state.data // Provides the data that you need to pass in the `/payments` call.
    // component // Provides the active component instance that called this event.
  }
  const configuration = withAdyenCountryCode({
    locale: "en_US",
    environment: "test",
    clientKey: "test_7IHEI5LYLVG4HLEQRG562U7A6EUPO2GZ",
    onChange: handleOnChange
  });
  const dealerOptions = async (ds) => {
    try {
      setDealersSelected(await loadDealerOptions(ds, async () => {
        const result = await firebase.functions().httpsCallable("appV2/getDealers")();
        return result.data.dealers;
      },
        { currentValues: [editRegistration?.dealer] }));
    } catch (error) {
      console.error("Unable to load dealer options.", error);
      toast.error("Unable to load dealer options.");
      setDealersSelected([{ value: "--", label: "No preference" }]);
    }
  }
  async function adyenInit() {
    const checkout = await AdyenCheckout(configuration);
    new CustomCard(checkout, {
      // Optional configuration
      type: 'card',
      brands: ['mc', 'visa', 'amex', 'bcmc', 'diners', 'discover', 'maestro'],
      styles: {
        base: {
        },
        error: {
          color: 'red'
        },
        validated: {
          color: 'green'
        },
        placeholder: {
          color: '#d8d8d8'
        }
      },
      // Events
      onChange: (r) => {
        if (r.isValid) {
          setPaymentMethod(r.data.paymentMethod);
        } else {
          setPaymentMethod(null);
        }
      },
      onValid: function () { },
      onLoad: function () { },
      onConfigSuccess: function () { },
      onFieldValid: function () { },
      onBrand: function () { },
      onError: function () { },
      onFocus: function () { },
      onBinValue: function (bin) { },
      onBinLookup: function (callbackObj) { }
    }).mount('#customCard-container');
  }
  const loadAdyen = async () => {
    // await adyenInit()
    // setAdyenLoaded(true);
  }
  const formatTime = (t) => {
    if (t) {
      let tm = t.split(":");
      let h = +tm[0];
      let m = tm[1];
      let ampm = "AM";
      if (h >= 12) {
        ampm = "PM";
      }
      if (h > 12) {
        h -= 12;
      }
      return h + ":" + m + " " + ampm;
    } else {
      return "";
    }
  }
  const isSessionReserved = (item) => {
    return Number(item?.reserved || 0) !== 0;
  }
  const getSessionAvailableCount = (session) => {
    return session?.items?.filter((item) => item.available && !isSessionReserved(item)).length || 0;
  }
  const getSessionReservedCount = (session) => {
    return session?.items?.filter((item) => item.available && isSessionReserved(item)).length || 0;
  }
  const renderSessionCapacity = (session) => {
    const reservedCount = getSessionReservedCount(session);
    return (
      <span className="fs-xxs">
        {getSessionAvailableCount(session)} Available
        {(eventData?.allowOverbooking || reservedCount > 0) && <> / {reservedCount} Reserved</>}
      </span>
    );
  }
  const isOverbookedSessionSelection = (session) => {
    return eventData?.allowOverbooking && getSessionAvailableCount(session) === 0 && getSessionReservedCount(session) === 0;
  }
  const loadCommerceItemAvailability = async (nextEventData, registration = null) => {
    const tickets = getCommerceItems(nextEventData);
    const capacityTickets = tickets.filter(
      (ticket) =>
        ticket.fieldCapacity === "eventCapacity" ||
        ticket.fieldCapacity === "itemCapacity",
    );
    const originalRegistration = registration
      ? tickets.reduce(
          (snapshot, ticket) => ({
            ...snapshot,
            [ticket.fieldName]: registration[ticket.fieldName],
          }),
          { status: registration.status },
        )
      : null;

    if (capacityTickets.length === 0) {
      setCommerceAvailability({
        error: null,
        eventSoldCount: 0,
        isLoaded: true,
        originalRegistration,
        soldCounts: {},
      });
      return;
    }

    const capacityEventId = nextEventData?.id || eventId;
    setCommerceAvailability({
      error: null,
      eventSoldCount: 0,
      isLoaded: false,
      originalRegistration,
      soldCounts: {},
    });

    try {
      if (!capacityEventId) {
        throw new Error("Event ID is unavailable.");
      }

      const eventCapacityRequest = capacityTickets.some(
        (ticket) => ticket.fieldCapacity === "eventCapacity",
      )
        ? firebase.functions().httpsCallable("appV2/regCount")({
            id: capacityEventId,
          })
        : Promise.resolve({ data: 0 });
      const itemCapacityTickets = capacityTickets.filter(
        (ticket) => ticket.fieldCapacity === "itemCapacity",
      );
      const itemCountRequest = firebase
        .functions()
        .httpsCallable("appV2/regItemCount");
      const [eventCountResult, ...itemCountResults] = await Promise.all([
        eventCapacityRequest,
        ...itemCapacityTickets.map((ticket) =>
          itemCountRequest({
            id: capacityEventId,
            fieldName: ticket.fieldName,
          }),
        ),
      ]);
      const eventSoldCount = Number(eventCountResult?.data);
      if (!Number.isFinite(eventSoldCount) || eventSoldCount < 0) {
        throw new Error("Event availability returned an invalid count.");
      }

      const soldCounts = itemCapacityTickets.reduce((counts, ticket, index) => {
        const soldCount = Number(itemCountResults[index]?.data);
        if (!Number.isFinite(soldCount) || soldCount < 0) {
          throw new Error(`${ticket.fieldName} returned an invalid count.`);
        }
        counts[ticket.fieldName] = soldCount;
        return counts;
      }, {});

      setCommerceAvailability({
        error: null,
        eventSoldCount,
        isLoaded: true,
        originalRegistration,
        soldCounts,
      });
    } catch (error) {
      console.error("Unable to load commerce-item availability.", error);
      setCommerceAvailability({
        error,
        eventSoldCount: 0,
        isLoaded: false,
        originalRegistration,
        soldCounts: {},
      });
      toast.error("Unable to load live commerce-item availability.");
    }
  };
  const getCommerceItemMaximum = (ticket) => {
    if (
      (ticket.fieldCapacity === "eventCapacity" ||
        ticket.fieldCapacity === "itemCapacity") &&
      !commerceAvailability.isLoaded
    ) {
      return 0;
    }

    return getCommerceItemSelectableMax(ticket, {
      tickets: getCommerceItems(eventData),
      eventData,
      soldCounts: commerceAvailability.soldCounts,
      eventSoldCount: commerceAvailability.eventSoldCount,
      originalRegistration: commerceAvailability.originalRegistration,
      registration: editRegistration,
    });
  };
  const isCommerceItemSoldOut = (ticket) =>
    (ticket.fieldCapacity === "eventCapacity" ||
      ticket.fieldCapacity === "itemCapacity") &&
    commerceAvailability.isLoaded &&
    getCommerceItemMaximum(ticket) === 0;
  const loadAdminCheckInData = async (registrationId) => {
    if (!registrationId) {
      return;
    }

    setCheckInData(null);
    setCheckInLoadedRegistrationId(null);
    try {
      const getCheckInData = firebase
        .functions()
        .httpsCallable("appV2/getCheckInData");
      const result = await getCheckInData({ regId: registrationId });
      if (result.data?.error) {
        toast.error(result.data.message || "Unable to load check-in details.");
        return;
      }
      if (!result.data?.notFound) setCheckInData(result.data);
    } catch (error) {
      toast.error(error.message || "Unable to load check-in details.");
    } finally {
      setCheckInLoadedRegistrationId(registrationId);
    }
  };
  const applyCheckInAction = async (action) => {
    setCheckInBusyActionKey(actionKey(action));
    try {
      const updateCheckIn = firebase
        .functions()
        .httpsCallable("appV2/updateCheckIn");
      const result = await updateCheckIn(action);
      if (result.data?.error) {
        toast.error(result.data.message || "Unable to update check-in.");
        return false;
      }

      setCheckInData(result.data);
      const updatedRegistration = [
        result.data?.primaryRegistration,
        result.data?.guestRegistration,
      ].find((registration) => registration?.id === editRegistration?.id);
      if (updatedRegistration) {
        setEditRegistration((currentRegistration) => ({
          ...currentRegistration,
          status: updatedRegistration.status,
        }));
      }
      return true;
    } catch (error) {
      toast.error(error.message || "Unable to update check-in.");
      return false;
    } finally {
      setCheckInBusyActionKey(null);
    }
  };
  const loadInit = async () => {
    let eData = null;
    try {
      if (!id || id === "new") {
        eData = (await db.collection("events").doc(eventId).get()).data();

        await loadCommerceItemAvailability(eData);
        setEventData(eData);
        sessionStorage.setItem("eventData", JSON.stringify(eData));
        setCurrentEventData(eData);
        newReg(eData);
        await setupSessions(eData);
        let pc = [];
        if (user.role <= 2) {
          pc.push("");
        }
        if (eData?.allowMultiUsePasscodes) {
          eData?.multiUsePasscodes?.forEach((item) => {
            if (user.role === 1 || !eData?.requireMultiUsePasscodes || !item.usersAllowed || item.usersAllowed?.length === 0 || (eData?.requireMultiUsePasscodes && item.usersAllowed?.find(o => o.name === user.email))) {
              pc.push({ code: item.passcode, name: item.label });
            }
          });
        }
        await dealerOptions(eData?.dealersSelected);

        setUserPasscodes(pc);
      } else {
        const result = await db.collection("registrations").doc(id).get();
        const registration = result.data();
        if (!registration) {
          throw new Error("Registration not found.");
        }

        eData = eventData;
        if (!eData) {
          eData = JSON.parse(sessionStorage.getItem("eventData"));
          setEventData(eData);
        }
        if (!eData || eData?.id !== registration.eventId) {
          const qs = await db
            .collection("events")
            .where("id", "==", registration.eventId)
            .limit(1)
            .get();
          if (qs.docs.length === 0) {
            throw new Error("Registration event not found.");
          }

          eData = qs.docs[0].data();
          eData.id = qs.docs[0].id;
          setCurrentEventData(eData);
          setEventData(eData);
        }
        await setupSessions(eData);
        const tmpResult = { ...registration };
        if (tmpResult.createdAt?.seconds) {
          tmpResult.createdAt = tmpResult.createdAt.seconds * 1000 + tmpResult.createdAt.nanoseconds / 1000000;
        }
        if (tmpResult.updatedAt?.seconds) {
          tmpResult.updatedAt = tmpResult.updatedAt.seconds * 1000 + tmpResult.updatedAt.nanoseconds / 1000000;
        }
        if (tmpResult.expiration?.seconds) {
          tmpResult.expiration = tmpResult.expiration.seconds * 1000 + tmpResult.expiration.nanoseconds / 1000000;
        }
        await loadCommerceItemAvailability(eData, tmpResult);
        if (!tmpResult?.adyenRef && arraySearch(eData?.additionalFields, "CommerceItem") >= 0) {
          loadAdyen();
        }
        if (tmpResult.sessionItemId != null) {
          setItemSelection((currentSelection) => ({
            ...currentSelection,
            itemId: tmpResult.sessionItemId,
          }));
        }
        updateUploads(eData?.allowUpload);
        let pc = [];
        if (user.role === 1) pc.push("");
        if (eData?.allowMultiUsePasscodes) {
          eData?.multiUsePasscodes?.forEach((item) => {
            if (user.role === 1 || !eData?.requireMultiUsePasscodes || !item.usersAllowed || item.usersAllowed?.length === 0 || (eData?.requireMultiUsePasscodes && item.usersAllowed?.find(o => o.name === user.email))) {
              pc.push({ code: item.passcode, name: item.label });
            }
          });
        }
        await dealerOptions(eData?.dealersSelected);
        setUserPasscodes(pc);
        setActivitySavedId(id);
        setEditRegistration(tmpResult);
      }
    } catch (error) {
      console.error("Unable to load registration.", error);
      toast.error(error.message || "Unable to load registration.");
      setInitialLoadError(error.message || "Unable to load registration.");
    } finally {
      setInitialLoadComplete(true);
    }
  };
      useEffect(() => {
      if (addressLookup) {
        geocodeByPlaceId(addressLookup.value.place_id)
          .then((results) => {
            console.log(results);
            if (results) {
              let address = results[0];
              let street_number = "";
              let route = "";
              let city = "";
              let state = "";
              let postal = "";
              let country = "";
              address.address_components.forEach((comp) => {
                if (comp.types.includes("street_number")) {
                  street_number = comp.long_name;
                }
                if (comp.types.includes("route")) {
                  route = comp.short_name;
                }
                if (comp.types.includes("locality")) {
                  city = comp.long_name;
                }
                if (comp.types.includes("administrative_area_level_1")) {
                  state = comp.short_name;
                }
                if (comp.types.includes("postal_code")) {
                  postal = comp.long_name;
                }
                if (comp.types.includes("country")) {
                  country = comp.short_name;
                }
              });
              document.getElementById("state").value = state;
              setEditRegistration({
                ...editRegistration,
                address1: street_number + " " + route,
                city: city,
                state: state,
                postal: postal,
                country: country
              });
            }
          })
          .catch(error => console.error(error));
      }
    }, [addressLookup]);
  useEffect(() => {
    if (!checkAuth()) return;
    // if (!checkEventData()) return;
    setInitialLoadComplete(false);
    setInitialLoadError(null);
    setCheckInLoadedRegistrationId(null);
    void loadInit();
    DOMPurify.setConfig({ ADD_ATTR: ['target'] });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reload only when the registration route changes
  }, [id, eventId]);
  useEffect(() => {
    if (disabledSend) {
      setTimeout(() => {
        setDisabledSend(false);
      }, 5000)
    }
  }, [disabledSend]);
  useEffect(() => {
    if (
      id &&
      id !== "new" &&
      editRegistration?.id &&
      editRegistration.id === id
    ) {
      void loadAdminCheckInData(editRegistration.id);
    } else {
      setCheckInData(null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps -- check-in data should reload only when the active registration changes
  }, [id, editRegistration?.id]);
  useEffect(() => {
    if (editRegistration && editRegistration.hasWaiver && !waiverUrl) {
      storage
        .child("/waivers/" + editRegistration?.id + ".pdf")
        .getDownloadURL()
        .then((url) => {
          setWaiverUrl(url);
        })
        .catch((e) => {
          // Sentry.captureException(e);
        });
    }
    if (editRegistration && editRegistration.hasWaiver && !waiverSigUrl) {
      storage
        .child("/waivers/" + editRegistration?.id + ".jpg")
        .getDownloadURL()
        .then((url) => {
          setWaiverSigUrl(url);
        })
        .catch((e) => {
          // Sentry.captureException(e);
        });
    }
    if (editRegistration && editRegistration.hasGuestWaiver && !waiverGuestUrl) {
      storage
        .child("/guest_waivers/" + editRegistration?.id + ".pdf")
        .getDownloadURL()
        .then((url) => {
          setWaiverGuestUrl(url);
        })
        .catch((e) => {
          // Sentry.captureException(e);
        });
    }
    if (editRegistration && editRegistration.hasGuestWaiver && !waiverGuestSigUrl) {
      storage
        .child("/guest_waivers/" + editRegistration?.id + ".jpg")
        .getDownloadURL()
        .then((url) => {
          setWaiverGuestSigUrl(url);
        })
        .catch((e) => {
          // Sentry.captureException(e);
        });
    }
  }, [editRegistration]);
  const deleteRegistration = () => {
    try {
      deleteFile("/waivers/", editRegistration.id + ".pdf");
      deleteFile("/waivers/", editRegistration.id + ".jpg");
    } catch (error) {
      console.log(error);
    }
    try {
      deleteFile("/guest_waivers/", editRegistration.id + ".pdf");
      deleteFile("/guest_waivers/", editRegistration.id + ".jpg");
    } catch (error) {
      console.log(error);
    }
    db.collection("registrations").doc(editRegistration.id).delete();
    setEditRegistration(null);
    setCompleteWaiver(false);
    setWaiverSigUrl(null);
    setWaiverUrl(null);
    setCompleteGuestWaiver(false);
    setWaiverGuestSigUrl(null);
    setWaiverGuestUrl(null);
    clearCanvas();
    history("/manage/registrations/" + eventData?.id);
  };
  const handleDeletePaymentLink = (e) => {
    e.preventDefault();
    var prod = eventData?.prodPayment;
    var deletePaymentLink = firebase.functions().httpsCallable("appV2/deletePaymentLink");
    deletePaymentLink({
      reg: editRegistration,
      prodPayment: prod
    })
      .then((result) => {
        // console.log(result);
        if (result.data.error) {
          alert(result.data.message);
          return;
        }
        setEditRegistration({ ...editRegistration, adyenLink: null, adyenLinkId: null, adyenLinkExpireDate: null })
      })
      .catch((error) => {
        alert("There was a problem reaching the service to create your payment link, try again later.");
      });
  };
  const handleWaivedPaymentLink = (e) => {
    e.preventDefault();
    setEditRegistration({ ...editRegistration, adyenPaymentStatus: 'Waived' });
  };
  const handleRefundedPaymentLink = (e) => {
    e.preventDefault();
    setEditRegistration({ ...editRegistration, adyenPaymentStatus: 'Refunded' });
    alert('Make sure to process refund in the Adyen system.  This is only a flag to show as refunded in eZentrum.');
  };
  const handleCreatePaymentLink = (e) => {
    e.preventDefault();
    if (!editRegistration.updatedAt) {
      alert('Save and close registration, then reload before creating payment link.')
      return;
    }
    var createPaymentLink = firebase.functions().httpsCallable("appV2/createPaymentLink");
    createPaymentLink({
      reg: editRegistration,
      prodPayment: eventData?.prodPayment,
      paymentTax: eventData?.paymentTax,
      additionalFields: eventData?.additionalFields
    })
      .then((result) => {
        // console.log(result);
        if (result.data.error) {
          alert(result.data.message);
          return;
        }
        setEditRegistration({ ...editRegistration, adyenLink: result.data.adyenLink, adyenLinkId: result.data.adyenLinkId, adyenLinkExpireDate: result.data.adyenLinkExpireDate, updatedAt: result.data.updatedAt })
      })
      .catch((error) => {
        console.log(error);
        alert("There was a problem reaching the service to create your payment link, try again later.");
      });
  };
  const handleSubmitNone = (e) => {
    e.preventDefault();
    handleSubmit("none");
  };
  const handleSubmitAndClose = (e) => {
    e.preventDefault();
    handleSubmit("close");
  };
  const handleSubmitAndNew = (e) => {
    e.preventDefault();
    handleSubmit("new");
  };
  const handleCheckInAndNew = (e) => {
    e.preventDefault();
    handleSubmit("new", true);
  };
  const handleSubmitAndGuest = (e) => {
    e.preventDefault();
    handleSubmit("guest");
  };
  const handleCheckInAndGuest = (e) => {
    e.preventDefault();
    handleSubmit("guest", true);
  };
  const handleCheckInAndClose = (e) => {
    e.preventDefault();
    handleSubmit("close", true);
  };
  const handleSubmit = (action, checkin) => {
    if (savingSignature) {
      alert('Waiver is still being saved, please try again.');
      return;
    }
    if (editRegistration?.sessionId && editRegistration.status === 'Waitlist') {
      alert('A waitlisted registration cannot be assigned to a session.');
      return;
    }
    if (editRegistration?.sessionId && editRegistration.status === 'Cancelled') {
      alert('A cancelled registration cannot be assigned to a session.  Please change status or clear the session.');
      return;
    }
    if (
      isCrmDataFieldRequired(eventData, "firstName", editRegistration) &&
      !editRegistration?.firstName
    ) {
      toast.error("First name is required.");
      return;
    }
    if (
      isCrmDataFieldRequired(eventData, "lastName", editRegistration) &&
      !editRegistration.lastName
    ) {
      toast.error("Last name is required.");
      return;
    }
    if (
      isCrmDataFieldRequired(eventData, "postal", editRegistration) &&
      !editRegistration.postal
    ) {
      toast.error("Postal code is required.");
      return;
    }
    // if (eventData?.allowPushToCap && !eventData?.skipDealerOptIn && editRegistration?.dealer_optin == null && (editRegistration?.status == "Registered" || editRegistration?.status == "Checked-In")) {
    //   toast.error("Dealer contact option is required.");
    //   return;
    // }
    // if (
    //   editRegistration.dealer_optin && !eventData?.skipPurchaseTimeFrame &&
    //   !editRegistration.purchaseTimeFrame
    // ) {
    //   toast.error("Purchase Timeframe is required.");
    //   return;
    // }
    // if (
    //   editRegistration.dealer_optin &&
    //   !editRegistration.modelInterest
    // ) {
    //   toast.error("Model Interest is required.");
    //   return;
    // }
    // if (
    //   eventData?.dataFields?.email?.visible &&
    //   eventData?.dataFields?.email?.required &&
    //   !editRegistration.email
    // ) {
    //   toast.error("Email is required.");
    //   return;
    // }
    if (sendEmailCheck && !editRegistration.email) {
      toast.error("Email is required to send confirmation email.");
      return;
    }
    let reg = editRegistration;
    let ts = firebase.firestore.FieldValue.serverTimestamp()
    // if (!reg.createdAt) {
    // reg.createdAt = ts;
    // reg.createdDate = moment(reg.createdAt.toDate()).format("MM/DD/YYYY h:mm A");
    // }
    // reg.updatedAt = ts;
    // console.log(dealersSelected[0].code);
    if (eventData?.endDate || eventData?.ongoingEvent) {
      // console.log(eventData?.endDate);
      // console.log(moment(eventData?.endDate));
      let exp = moment(eventData?.endDate ? eventData?.endDate : "").clone().add(91, 'days');
      // console.log(exp.format("MM/DD/YYYY h:mm A"));
      reg.expiration = exp.format("MM/DD/YYYY h:mm A");
    }
    if (dealersSelected && dealersSelected?.length === 1) reg.dealer = dealersSelected[0].code;
    if (eventData?.allowWaivers) {
      if (!reg.hasWaiver || !reg.hasGuestWaiver) {

        if (waiverSigUrl && completeWaiver) {
          createWaiverPdf(document.getElementById("waiver-print"))
            .then(async (doc) => {
              const upload = await storage
                .child("/waivers/" + reg.id + ".pdf")
                .put(doc.output("blob"), { contentType: "application/pdf" });
              setWaiverUrl(await upload.ref.getDownloadURL());
              reg.hasWaiver = true;
              saveRegistration(reg, action, checkin);
            })
            .catch((error) => {
              console.error("Unable to save waiver PDF.", error);
              toast.error("There was an error saving the waiver. Please try again.");
            });
        } else if (waiverGuestSigUrl && completeGuestWaiver) {
          createWaiverPdf(document.getElementById("waiver-guest-print"))
            .then(async (doc) => {
              const upload = await storage
                .child("/guest_waivers/" + reg.id + ".pdf")
                .put(doc.output("blob"), { contentType: "application/pdf" });
              setWaiverGuestUrl(await upload.ref.getDownloadURL());
              reg.hasGuestWaiver = true;
              saveRegistration(reg, action, checkin);
            })
            .catch((error) => {
              console.error("Unable to save waiver PDF.", error);
              toast.error("There was an error saving the waiver. Please try again.");
            });
        } else {
          saveRegistration(reg, action, checkin);
        }
      } else {
        saveRegistration(reg, action, checkin);
      }
    } else {
      saveRegistration(reg, action, checkin);
    }
    // const dataURL = sigCanvas.current.toDataURL();
    // setSignatureResult(dataURL)
    // onSave(dataURL)
    // setIsVisible(!isVisible)
  };
  let pc = eventData?.multiUsePasscodes;
  const previewEmail = async () => {
    if (eventData?.allowConfirmationEmail && editRegistration.email) {
      var sendEmail = firebase
        .functions()
        .httpsCallable("appV2/sendConfirmationEmail");
      sendEmail({ reg: editRegistration, eventData: eventData, preview: true })
        .then((result) => {
          if (result?.data.error) {
            toast.warning(result?.data.message);
            return;
          }
          else {
            setPreviewEmailHtml(result?.data.message);
          }
        })
        .catch((e) => {
          // Sentry.captureException(e);
          toast.error(e.message);
        });
    }
  }
  const lookupDaysAhead = (date) => {
    let daysAhead = eventData?.daysAhead || -90;
    let m = moment(date).diff(moment(), 'days');

    if (m >= daysAhead) {
      return true;
    }
    else {
      console.log(date);
      return false;
    }
  }
  const saveRegistration = async (reg, action, checkin = false) => {
    if (savingRegistration) return;
    setSavingRegistration(true);
    try {
    clearCanvas();
    clearGuestCanvas();
    //if dup email allowed or no dup email
    //if allow dealer and 1 matches or at least there if none or more
    let guestId = db.collection("registrations").doc().id
    if (action == "guest") {
      reg.guestId = guestId;
    }
    reg.adminSave = true;
    // console.log(reg);
    // console.log('test');
    if (!reg.passcode && eventData?.allowPasscodes && eventData?.requireMultiUsePasscodes) {
      if (userPasscodes.length === 1) {
        let passcode = userPasscodes[0].code;
        reg.passcode = passcode;
        let pc = eventData?.multiUsePasscodes?.find(o => o.passcode.toUpperCase() === passcode.toUpperCase());
        if (pc && pc.disableAllLeads) {
          reg.disableLead = true;
        } else {
          reg.disableLead = false;
        }
        if (pc && eventData?.allowMultiUsePasscodes && eventData?.multiUsePasscodes && eventData?.multiUsePasscodes.length > 0 && !reg.dealer) {
          reg.dealer = pc.dealer;
        }
      } else {
        toast.error('Passcode is required.');
        return;
      }
    }

    if (!reg.sessionId && user.role > 2 && eventData?.allowPasscodes && eventData?.requireMultiUsePasscodes) {
      toast.error("Session date and time are required.");
      return;
    }
    if (!reg.sessionId && user.role <= 2 && eventData?.allowPasscodes && eventData?.requireMultiUsePasscodes) {
      console.log(reg.passcode);
      console.log(eventData?.sessions);
      let s = eventData?.sessions.find(o => o.passcode.toUpperCase() === reg.passcode.toUpperCase());
      console.log(s);
      if (s) {
        reg.sessionItemId = itemSelection?.itemId;
        reg.sessionItem = eventData?.sessionItems[itemSelection.itemId].name;
        reg.sessionDate = moment(s.startTime).format("dddd MMMM Do YYYY");
        reg.sessionTime = formatTime(s.startTime.split(" ")[1]);
        reg.sessionEndDate = moment(s.endTime).format("dddd MMMM Do YYYY");
        reg.sessionEndTime = formatTime(s.endTime ? s.endTime.split(" ")[1] : "");
      }

      console.log(reg);
    }

    if ((reg.status === 'Checked-In' || reg.status === 'Registered') && eventData?.capacityType === "session" && Object.keys(eventData?.sessionItems[itemSelection?.itemId]?.sessions || {}).length > 0 && !reg.sessionDate) {
      console.log(eventData?.sessionItems[itemSelection?.itemId]);
      // if(eventData?.requireMultiUsePasscodes && )
      toast.error('Session date and time should be entered if available for checked-in or registered status.');
      // return;
    }
    // console.log(reg);
    var saveReg = firebase.functions().httpsCallable("appV2/saveReg");
    let result = await saveReg({
      reg: reg,
      eventData: eventData,
      guestReg: null
    });
    if (result.data.error) {
      alert(result.data.message);
      return;
    }
    if (checkin) {
      const checkInSucceeded = await applyCheckInAction({
        checked: true,
        registrationId: reg.id,
        target: "participant",
      });
      if (!checkInSucceeded) return;
      reg.status = "Checked-In";
    }
    // alert('saved');
    // db.collection("registrations").doc(reg.id).set(reg);
    if (sendEmailCheck && eventData?.allowConfirmationEmail && reg.email) {
      var sendEmail = firebase
        .functions()
        .httpsCallable("appV2/sendConfirmationEmail");
      sendEmail({ reg: reg, eventData: eventData })
        .then((result) => {
          if (result?.data.error) {
            toast.warning(result?.data.message);
            return;
          }
          setSendEmailCheck(false);
          setActivityRefreshKey((value) => value + 1);
        })
        .catch((e) => {
          // Sentry.captureException(e);
          toast.error(e.message);
        });
    }
    setActivitySavedId(reg.id);
    setActivityRefreshKey((value) => value + 1);
    toast.success("Saved");
    if (action === "close") {
      history("/manage/registrations/" + eventData?.id);
    } else if (action === "new") {
      setCompleteWaiver(false);
      setCompleteGuestWaiver(false);
      history('/manage/registration');
      newReg();
    } else if (action === "guest") {
      setCompleteWaiver(false);
      setCompleteGuestWaiver(false);
      history('/manage/registration');
      guestReg(guestId, reg.id);
    }
    } catch (error) {
      toast.error(error.message || "Registration could not be saved. Your changes are preserved.");
    } finally { setSavingRegistration(false); }
  };
  const handleChange = (e) => {
    setEditRegistration({
      ...editRegistration,
      [e.target.name]: e.target.name === "email" ? e.target.value.toLowerCase() : e.target.value,
    });
  };
  const handleRegistrationFlagChange = (field, checked) => {
    setEditRegistration({
      ...editRegistration,
      [field]: checked,
    });
  };
  const handlePhoneChange = (e) => {
    let tmpPhone = e.target.value.replace(/\D/g, '');

    if (tmpPhone.length > 10) {
      tmpPhone = tmpPhone.slice(0, 10);
    }
    if (tmpPhone.length > 6) {
      tmpPhone = tmpPhone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }


    setEditRegistration({
      ...editRegistration,
      [e.target.name]: tmpPhone,
    });
  }
  const handleChangeCommerceItem = async (e, cost) => {
    let formatterUSD = new Intl.NumberFormat('en-US', {
      roundingMode: 'halfCeil',
      style: 'currency',
      currency: 'USD'
    });
    // let qty = +e.target.value;
    // let subCost,taxCost,totalCost;
    // if(tax) {
    // subCost = formatterUSD.format(cost * qty);
    // taxCost = formatterUSD.format(cost * qty * (tax / 100));
    // totalCost = formatterUSD.format(cost * qty * (1 + tax / 100));
    // } else {
    //   subCost = formatterUSD.format(cost * qty);
    //   taxCost = formatterUSD.format(0);
    //   totalCost = formatterUSD.format(cost * qty);
    // }
    let tmpSub = 0;
    let tmpItem = +e.target.value * cost;
    if (eventData?.additionalFields) {
      eventData?.additionalFields.map((dataField, index) => {
        if (dataField.fieldType === "CommerceItem") {
          let qty = 0;
          if (e.target.name === dataField.fieldName)
            qty = +e.target.value;
          else
            qty = +editRegistration[dataField.fieldName];
          if (qty)
            tmpSub += qty * +dataField.fieldCost;
        }
      });
    }
    // let qty = +e.target.value;
    let tax = +eventData?.paymentTax;
    let subCost, taxCost, totalCost;
    if (tax) {
      subCost = formatterUSD.format(tmpSub);
      taxCost = formatterUSD.format(tmpSub * (tax / 100));
      totalCost = formatterUSD.format(tmpSub * (1 + tax / 100));
    } else {
      subCost = formatterUSD.format(tmpSub);
      taxCost = formatterUSD.format(0);
      totalCost = formatterUSD.format(tmpSub);
    }
    setEditRegistration({
      ...editRegistration,
      // [e.target.name]: e.target.value, [e.target.name + "Cost"]: totalCost, [e.target.name + "TaxCost"]: taxCost, [e.target.name + "SubCost"]: subCost
      [e.target.name]: e.target.value, [e.target.name + "Cost"]: formatterUSD.format(tmpItem), "taxCost": taxCost, "subCost": subCost, "totalCost": totalCost
    });
    // if (!adyenLoaded && paymentType === 'payment') {
    //   await adyenInit()
    //   setAdyenLoaded(true);
    // }
  };
  const handlePostal = (e) => {
    setEditRegistration({
      ...editRegistration,
      [e.target.name]: e.target.value,
    });
  };
  const downloadWaiver = async (e, waiverUrl) => {
    e.preventDefault();
    if (waiverUrl) {
      window.fetch(waiverUrl).then((res) => {
        res.blob().then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = "waiver_" + editRegistration.id + ".pdf"; // the filename you want
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        });
      });
    }
  };
  const downloadGuestWaiver = async (e, waiverUrl) => {
    e.preventDefault();
    if (waiverUrl) {
      window.fetch(waiverUrl).then((res) => {
        res.blob().then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = "guest_waiver_" + editRegistration.id + ".pdf"; // the filename you want
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        });
      });
    }
  };
  const setupSessions = async (eData) => {
    // console.log(eData);
    if (eData?.allowCapacity && eData?.capacityType === "session") {
      var updateSessionAvailability = await firebase.functions().httpsCallable("appV2/updateSessionAvailability");
      // console.log(eData.sessions);
      let sessionAvailability = await updateSessionAvailability({
        sessions: eData.sessions,
        eventId: eData.id,
        skipReserved: true,
        deviceId: GetDeviceId()
      });
      eData.sessions = sessionAvailability.data.sessions;
      
      eData?.sessionItems?.forEach((item, index) => {
        //filter passcodes as needed.
        //restrict passcode here if required
        //  console.log(item);
        let session = eData.sessions.filter(o => o.itemIndex === index);
        // console.log(session);
        if (session) {
          let days = {};
          
          session.forEach((s, i) => {
            // console.log(s.passcode);
            // console.log(eData?.multiUsePasscodes.find(o => o.passcode === s.passcode));
            if (eData?.allowPasscodes && eData?.requireMultiUsePasscodes && user.role > 1 && eData?.multiUsePasscodes.find(o => o.passcode === s.passcode)?.usersAllowed?.length > 0 && !eData?.multiUsePasscodes.find(o => o.passcode === s.passcode)?.usersAllowed?.find(o => o.name === user.email)) {
              s.available = false;
            }
            if (eData?.allowPasscodes && eData?.requireMultiUsePasscodes && editRegistration?.passcode && editRegistration?.passcode.toUpperCase().indexOf(s.passcode.toUpperCase()) < 0) {
              s.available = false;
            }
            // console.log(s);
            if (s.available || eData?.allowOverbooking) {
              let d = s.startTime.split(" ")[0];
              let t = s.startTime.split(" ")[1];
              let ed = s.endTime ? s.endTime.split(" ")[0] : d;
              let end_t = s.endTime ? s.endTime.split(" ")[1] : "";
              if (!days[d]) days[d] = [];
              let dCheck = days[d].find(o => o.time === t);
              let sessionItem = { itemIndex: s.itemIndex, available: s.available, reserved: s.reserved || 0, startTime: s.startTime, passcode: s.passcode, label: s.label, link: s.link, linkLabel: s.linkLabel, ics:s.ics, id: s.id };
              if (!dCheck)
                days[d].push({ date: d, time: t, end_ed: ed, end: end_t, startTime: s.startTime, link: s.link, linkLabel: s.linkLabel,ics:s.ics, label:s.label?.replace('|',','), items: [sessionItem] });
              else {
                // console.log(days[d]);
                dCheck.items.push(sessionItem);
              }
            }
          });
          let tmpItemId = editRegistration?.sessionItemId;
          if (eData?.sessionItems.length == 1) {
            tmpItemId = 0;
          }
          setItemSelection({ deviceId: GetDeviceId(), eventId: eData.id, itemId: tmpItemId, dateSel: null, timeSel: null, sessionId: null });
          item.sessions = days;
          
          
        }
      });
      console.log(eData);
      setEventData(eData);
      setSessionsLoaded(true);
    }
  }
  useEffect(() => {
    checkAuth();
  }, [user]);
  useEffect(() => {
    console.log('setting up sessions');
    setupSessions(eventData);
  }, [editRegistration?.passcode]);
  const checkAuth = () => {
    if (!user.isAuthenticated) {
      history("/manage/sign-in");
      return false;
    } else {
      return true;
    }
  };
  const switchReg = (id) => {
    db.collection("registrations").doc(id).get()
      .then((result) => {
        history('/manage/registration/' + id);
        let tmpResult = result.data();
        if (tmpResult.createdAt.seconds) {
          tmpResult.createdAt = tmpResult.createdAt.seconds * 1000 + tmpResult.createdAt.nanoseconds / 1000000
        }
        if (tmpResult.updatedAt.seconds) {
          tmpResult.updatedAt = tmpResult.updatedAt.seconds * 1000 + tmpResult.updatedAt.nanoseconds / 1000000
        }
        console.log(tmpResult);
        console.log(editRegistration);
        console.log(itemSelection);
        setEditRegistration(tmpResult);
        if (tmpResult.sessionItemId != null) {
          setItemSelection({ ...itemSelection, itemId: tmpResult.sessionItemId });
        }
        void loadAdminCheckInData(tmpResult.id);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  const initialPageReady =
    initialLoadComplete &&
    (!id ||
      id === "new" ||
      initialLoadError ||
      (editRegistration?.id &&
        checkInLoadedRegistrationId === editRegistration.id));

  if (!initialPageReady) {
    return (
      <div className="fixed inset-0 z-[1000] flex min-h-screen items-center justify-center bg-white dark:bg-zinc-900">
        <div className="flex flex-col items-center gap-4">
          <LoadingIndicator size="lg" />
          <p className="text-sm text-zinc-600 dark:text-zinc-300">
            Loading registration…
          </p>
        </div>
      </div>
    );
  }

  if (initialLoadError) {
    return (
      <div className="container py-5" role="alert">
        <h1>Unable to load registration</h1>
        <p>{initialLoadError}</p>
        <button
          className="btn btn-default"
          onClick={() => history("/manage/registrations")}
        >
          Back to registrations
        </button>
      </div>
    );
  }

  return (
    <div className="container registration-detail">
      <header className="registration-header">
        <div><a href={"/manage/registrations/" + eventData?.id} className="text-sm underline underline-offset-4">Back to registrations</a>
        <h1 className="mt-3">{editRegistration?.firstName || editRegistration?.lastName ? `${editRegistration?.firstName || ""} ${editRegistration?.lastName || ""}`.trim() : "New registration"}</h1>
        <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">{editRegistration?.isGuest ? "Guest registration" : "Registration"} · {getRegistrationStatusLabel(editRegistration)}</p></div>
        <nav aria-label="Registration sections" className="flex flex-wrap gap-2 text-sm">
          <a className="registration-section-link" href="#registration-contact">Contact</a>
          <a className="registration-section-link" href="#registration-details">Details</a>
          <a className="registration-section-link" href="#registration-notes">Notes</a>
          <a className="registration-section-link" href="#registration-email-history">Email history</a>
        </nav>
      </header>
      <TestPaymentModeBanner eventData={eventData} />
      <div className="registration-reference">Reference: {editRegistration?.id} {editRegistration?.passcodeUsed ? " | " + editRegistration?.passcodeUsed : ""}</div>
      {editRegistration?.guestId &&
        <button className="btn btn-default p-0" onClick={() => { switchReg(editRegistration.guestId); }}>View guest registration</button>
      }
      {editRegistration?.parentId &&
        <button className="btn btn-default p-0" onClick={() => { switchReg(editRegistration.parentId); }}>View primary registration</button>
      }
      <BarcodeReader onError={handleScanError} onScan={handleScan} />
      <div className="py-2"></div>
      {checkInData && (
        <section className="registration-section mb-4" id="registration-check-in">
          <h2>Check-In</h2>
          <RegistrationCheckInPanel
            busyActionKey={checkInBusyActionKey}
            checkInData={checkInData}
            onAction={applyCheckInAction}
          />
        </section>
      )}
      {(eventData?.allowCapacity && eventData?.capacityType === "session") &&
        <>
          {eventData?.allowPasscodes &&
            <>
              <label>Passcode</label>
              {eventData?.allowMultiUsePasscodes && <>
                <select
                  className="form-control"
                  id="passcode"
                  name="passcode"
                  onChange={(e) => {
                    let tmpDealer = editRegistration?.dealer;
                    let pc = eventData?.multiUsePasscodes?.find(o => o.passcode.toUpperCase() === e.target.value.toUpperCase());
                    let disableLead = false;
                    if (pc && pc.disableAllLeads) {
                      disableLead = true;
                    }

                    if (pc && e.target.value && eventData?.allowMultiUsePasscodes && eventData?.multiUsePasscodes && eventData?.multiUsePasscodes.length > 0 && pc.dealer) {
                      tmpDealer = pc.dealer;
                    }
                    setEditRegistration({
                      ...editRegistration,
                      [e.target.name]: e.target.value,
                      dealer: tmpDealer,
                      disableLead: disableLead
                    });
                  }}
                  disabled={editRegistration?.sessionId}
                  value={editRegistration?.passcode?.toUpperCase()}
                >
                  
                  {userPasscodes.map((item, index) => (
                    <option key={"e" + index} value={item?.code?.toUpperCase()}>{item?.code ? (item?.code?.toUpperCase() + (item.name ? " - " + item?.name : "")) : ""}</option>
                  ))}
                </select>
              </>
              }
              {!eventData?.allowMultiUsePasscodes && <>
                <div>{editRegistration?.passcode ? editRegistration?.passcode : "Not Available"}</div>
              </>
              }
            </>
          }
          <div className="py-2"></div>
          {eventData?.sessionItems.length > 1 && (!itemSelection || itemSelection?.itemId == null) && !editRegistration?.sessionId && <>
            <h2>Make a selection</h2>
            <div className="row">
              {eventData?.sessionItems.map((item, index) => (
                <Fragment key={"f" + index}>
                  {item?.sessions && <>
                    {Object.keys(item.sessions).length > 0 &&
                      <div key={"g" + index} className="pointer col-xl-3 col-lg-3 col-md-4 col-sm-6 pb-5"
                        onClick={() => {
                          setItemSelection({ ...itemSelection, itemId: index });
                        }}
                      >
                        <div className="item-container me-3">
                          <img src={"/assets/items/" + item.slug + ".png"} alt={item.name} />
                          <label className="fs-md">{item.name}</label>
                          <div className="fs-sm">{item.description}</div>
                        </div>
                      </div>
                    }
                  </>
                  }
                </Fragment>
              ))}
            </div>
          </>
          }
          {itemSelection?.itemId != null && editRegistration && !editRegistration?.sessionId && sessionsLoaded && <>
            {eventData?.sessionItems?.length > 1 && itemSelection && itemSelection.itemId != null && <>
              <h2>{eventData?.sessionItems ? eventData?.sessionItems[itemSelection?.itemId].name : ""}</h2>
              <div className="fs-xs underline pointer mb-4" onClick={() => { setItemSelection({ ...itemSelection, itemId: null }) }}>Back</div>
            </>
            }
            <h2 className="pb-2">{eventData?.sessionLabel ? eventData?.sessionLabel : "Select a date and time"}</h2>
            {itemSelection && itemSelection.itemId != null && <>

              {(Object.keys(eventData?.sessionItems[itemSelection?.itemId]?.sessions || {}).length == 0) && <div className="alert alert-danger">No sessions available.</div>}
              <div className="condensed">
                {Object.keys(eventData?.sessionItems[itemSelection?.itemId]?.sessions || {}).map((d, index) => (
                  <Fragment key={"a" + index}>
                    {lookupDaysAhead(d)}
                    {lookupDaysAhead(d) &&
                      <div key={"h" + index} className="date-container pb-4"
                      >
                        {eventData?.sessionItems[itemSelection?.itemId]?.sessions[d].length > 0 && !eventData?.condensedSessions &&
                          <h4>{moment(d).format("dddd MMMM Do YYYY")}</h4>
                        }
                        <div className="row">
                          {eventData?.sessionItems[itemSelection?.itemId]?.sessions[d].length === 0 && <div class="col"><div className="alert alert-danger">No sessions available</div></div>}
                          {eventData?.sessionItems[itemSelection?.itemId]?.sessions[d].map((s, index) => (
                            <div key={"b" + index} className="col-auto p-2">
	                              <div
	                                onClick={async () => {
                                    if (isOverbookedSessionSelection(s)) {
                                      let check = window.confirm("This session has no available or reserved spots. Continuing will overbook this registration. Do you want to add anyway?");
                                      if (!check) return;
                                      setEditRegistration(
                                        {
                                          ...editRegistration,
                                          sessionId: -1,
                                          sessionItemId: itemSelection?.itemId,
                                          sessionItem: eventData?.sessionItems[itemSelection.itemId].name,
                                          sessionDate: moment(d).format("dddd MMMM Do YYYY"),
                                          sessionTime: formatTime(s.time),
                                          sessionEndDate: moment(s.end_ed).format("dddd MMMM Do YYYY"),
                                          sessionEndTime: formatTime(s.end),
                                          sessionLabel: s?.label ? s?.label : null,
                                          sessionLink: s.link ? s.link : null,
                                          sessionLinkLabel: s.linkLabel ? s.linkLabel : null,
                                          sessionICS: s.ics ? s.ics : null
                                        });
                                      return;
                                    }
	                                  // console.log(itemSelection?.itemId);
	                                  var saveSession = await firebase.functions().httpsCallable("appV2/saveSession");
                                  let sessionId = await saveSession({
                                    itemId: itemSelection?.itemId,
                                    eventId: eventData?.id,
                                    deviceId: GetDeviceId(),
                                    startTime: s.startTime,
                                    endTime: s.endTime,
                                    link: s.link,
                                    linkLabel: s.linkLabel,
                                    ics: s.ics,
                                    label: s.label,
                                    items: s.items
                                  });
	                                  if (sessionId.data.error) {
	                                    if(user.role <= 3) {
	                                      let check = window.confirm(eventData?.allowOverbooking ? "The selected session is no longer available. Continuing will overbook this registration. Do you want to add anyway?" : "Session is not available, do you want to add anyway?") ;
	                                      if(check) {
                                      setEditRegistration(
                                        { 
                                          ...editRegistration,
                                          sessionId: -1,
                                          sessionItemId: itemSelection?.itemId,
                                          sessionItem: eventData?.sessionItems[itemSelection.itemId].name,
                                          sessionDate: moment(d).format("dddd MMMM Do YYYY"),
                                          sessionTime: formatTime(s.time),
                                          sessionEndDate: moment(s.end_ed).format("dddd MMMM Do YYYY"),
                                          sessionEndTime: formatTime(s.end),
                                          sessionLabel: s?.label ? s?.label : null,
                                          sessionLink: s.link ? s.link : null,
                                          sessionLinkLabel: s.linkLabel ? s.linkLabel : null,
                                          sessionICS: s.ics ? s.ics : null
                                        });
                                      }
                                    }else {
                                    alert(sessionId.data.message);
                                    }
                                  } else {
                                    setEditRegistration({
                                      ...editRegistration,
                                      sessionId: sessionId.data.id,
                                      sessionItemId: itemSelection?.itemId,
                                      sessionItem: eventData?.sessionItems[itemSelection.itemId].name,
                                      sessionDate: moment(d).format("dddd MMMM Do YYYY"),
                                      sessionTime: formatTime(s.time),
                                      sessionEndDate: moment(s.end_ed).format("dddd MMMM Do YYYY"),
                                      sessionEndTime: formatTime(s.end),
                                      sessionLabel: s?.label ? s?.label : null,
                                      sessionLink: s.link ? s.link : null,
                                      sessionLinkLabel: s.linkLabel ? s.linkLabel : null,
                                      sessionICS: s.ics ? s.ics : null
                                    });
                                  }
                                }}
	                                data-available={getSessionAvailableCount(s)} className="btn btn-theme time-btn no-line-height">
	                                  {s?.label ? (<><span dangerouslySetInnerHTML={{ __html: s.label }}></span><br />{renderSessionCapacity(s)}</>) : (<>
	                                    {eventData?.condensedSessions ? moment(d).format("MMMM Do, YYYY") : ""}
	                                    {!eventData?.hideSessionTimes ? formatTime(s.time) + (s.end ? " - " + formatTime(s.end) : "") : ""}
                                    <br />{renderSessionCapacity(s)}
	                                  </>)}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    }</Fragment>
                ))}
              </div>
            </>
            }
          </>
          }
          {editRegistration?.sessionId && <>
            {eventData?.sessionItems?.length > 1 && itemSelection && itemSelection.itemId != null && <>
              <h2>{eventData?.sessionItems[itemSelection?.itemId].name}</h2>
              {/* <div className="fs-xs underline pointer mb-4" onClick={() => { setItemSelection({ ...itemSelection, itemId: null }) }}>Back</div> */}
            </>
            }
            <h3>{editRegistration.sessionLabel ? <span dangerouslySetInnerHTML={{ __html: editRegistration?.sessionDate + '<br/>' + editRegistration.sessionLabel }}></span> : ""} {editRegistration?.sessionLabel ? "" : editRegistration.sessionDate} {!eventData?.hideSessionTimes && !editRegistration?.sessionLabel  ? editRegistration.sessionTime : ""}{!eventData?.hideSessionTimes && !editRegistration?.sessionLabel ? (editRegistration?.sessionEndTime ? " - " + editRegistration?.sessionEndTime : "") : ""} </h3>
            <div className="pb-3">
              <span className="fs-xs underline pointer"
                onClick={() => {
                  setEditRegistration({ ...editRegistration, sessionId: null, sessionItemId: null, sessionDate: null, sessionTime: null })
                }}
              >Change/Clear</span>
            </div>
            <hr />
          </>}
        </>
      }
      <div className="py-2"></div>
      <div className="row">
        <div className="col-12 registration-form">
          <h2 id="registration-contact" className="registration-section-title">Contact information</h2>
          <div
            className={
              eventData?.dataFields?.company?.visible || eventData?.dataFields?.company?.adminOnly ? "form-group" : "d-none"
            }
          >
            <label className="form-label" htmlFor="company">
              Company{" "}
              {isCrmDataFieldRequired(eventData, "company", editRegistration)
                ? "*"
                : ""}
            </label>
            <input
              type="text"
              id="company"
              name="company"
              value={editRegistration?.company || ""}
              onChange={handleChange}
              className="form-control"
              required={
                isCrmDataFieldRequired(eventData, "company", editRegistration)
                  ? true
                  : false
              }
            />
          </div>
          <div className="row">
            <div
              className={
                eventData?.dataFields?.title?.visible || eventData?.dataFields?.title?.adminOnly ? "col-md-auto" : "d-none"
              }
            >
              <div className={"form-group"}>
                <label className="form-label" htmlFor="title">
                  Title{" "}
                  {isCrmDataFieldRequired(eventData, "title", editRegistration)
                    ? "*"
                    : ""}
                </label>
                <select
                  className="form-control"
                  id="title"
                  name="title"
                  onChange={(e) => {
                    setEditRegistration({
                      ...editRegistration,
                      title: e.target.value,
                    });
                  }}
                  value={editRegistration?.title}
                  required={
                    isCrmDataFieldRequired(eventData, "title", editRegistration)
                      ? true
                      : false
                  }
                >
                  <option value=""></option>
                  <option value="1">Mr.</option>
                  <option value="3">Ms.</option>
                  <option value="2">Mrs.</option>
                  <option value="4">Dr.</option>
                </select>
              </div>
            </div>
            <div
              className={
                eventData?.dataFields?.firstName?.visible || eventData?.dataFields?.firstName?.adminOnly ? "col-md" : "d-none"
              }
            >
              <div className="form-group">
                <label className="form-label" htmlFor="firstName">
                  First Name{" "}
                  {isCrmDataFieldRequired(eventData, "firstName", editRegistration)
                    ? "*"
                    : ""}
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={editRegistration?.firstName || ""}
                  onChange={handleChange}
                  className="form-control"
                  required={
                    isCrmDataFieldRequired(eventData, "firstName", editRegistration)
                      ? true
                      : false
                  }
                />
              </div>
            </div>
            <div
              className={
                eventData?.dataFields?.lastName?.visible || eventData?.dataFields?.lastName?.adminOnly ? "col-md" : "d-none"
              }
            >
              <div className="form-group">
                <label className="form-label" htmlFor="lastName">
                  Last Name{" "}
                  {isCrmDataFieldRequired(eventData, "lastName", editRegistration)
                    ? "*"
                    : ""}
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={editRegistration?.lastName || ""}
                  onChange={handleChange}
                  className="form-control"
                  required={
                    isCrmDataFieldRequired(eventData, "lastName", editRegistration)
                      ? true
                      : false
                  }
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className={
                eventData?.dataFields?.email?.visible || eventData?.dataFields?.email?.adminOnly ? "col-md" : "d-none"
              }
            >
              <div className="form-group">
                <label className="form-label" htmlFor="email">
                  Email Address{" "}
                  {isCrmDataFieldRequired(eventData, "email", editRegistration)
                    ? "*"
                    : ""}
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={editRegistration?.email || ""}
                  onChange={handleChange}
                  className="form-control"
                  required={
                    isCrmDataFieldRequired(eventData, "email", editRegistration)
                      ? true
                      : false
                  }
                />
              </div>
              <label className="alert alert-warning fs-xs">Leave email blank if not available.  Do not use invalid email addresses.</label>
            </div>
            <div
              className={
                eventData?.dataFields?.phone?.visible || eventData?.dataFields?.phone?.adminOnly ? "col-md" : "d-none"
              }
            >
              <div className="form-group">
                <label className="form-label" htmlFor="phone">
                  Phone Number{" "}
                  {isCrmDataFieldRequired(eventData, "phone", editRegistration)
                    ? "*"
                    : ""}
                </label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={editRegistration?.phone || ""}
                  onChange={handlePhoneChange}
                  className="form-control"
                  required={
                    isCrmDataFieldRequired(eventData, "phone", editRegistration)
                      ? true
                      : false
                  }
                />
              </div>
            </div>
          </div>
                                                                        {eventData?.addressLookup && 

                                <div>
                                      <label className="form-label" htmlFor="addressLookup">
Lookup Address or enter manually below
                                  </label>
                                                           <GooglePlacesAutocomplete
                  apiKey="AIzaSyDcVJgAZaNN3ePD5JAKBUQD8ZFelonhlS8"
                  apiOptions={{ language: 'en', region: 'us' }}
                  autocompletionRequest={{
                    componentRestrictions: {
                      country: ['us'],
                    }
                  }}
                  onLoadFailed={(error) => (
                    console.error("Could not inject Google script", error)
                  )}
                  selectProps={{
                    addressLookup,
                    onChange: setAddressLookup,
                    autoComplete: false,
                    classNamePrefix: 'manage-select',
                  }}
                />
                <div className="py-2">  </div>
                </div>
  }
          <div
            className={
              eventData?.dataFields?.address1?.visible || eventData?.dataFields?.address1?.adminOnly ? "form-group" : "d-none"
            }
          >
            <label className="form-label" htmlFor="address1">
              Address 1{" "}
              {isCrmDataFieldRequired(eventData, "address1", editRegistration)
                ? "*"
                : ""}
            </label>
            <input
              type="text"
              id="address1"
              name="address1"
              value={editRegistration?.address1 || ""}
              onChange={handleChange}
              className="form-control"
              required={
                isCrmDataFieldRequired(eventData, "address1", editRegistration)
                  ? true
                  : false
              }
            />
          </div>
          <div
            className={
              eventData?.dataFields?.address2?.visible || eventData?.dataFields?.address2?.adminOnly ? "form-group" : "d-none"
            }
          >
            <label className="form-label" htmlFor="address2">
              Address 2{" "}
              {isCrmDataFieldRequired(eventData, "address2", editRegistration)
                ? "*"
                : ""}
            </label>
            <input
              type="text"
              id="address2"
              name="address2"
              value={editRegistration?.address2 || ""}
              onChange={handleChange}
              className="form-control"
              required={
                isCrmDataFieldRequired(eventData, "address2", editRegistration)
                  ? true
                  : false
              }
            />
          </div>
          <div className="row">
            <div
              className={
                eventData?.dataFields?.city?.visible || eventData?.dataFields?.city?.adminOnly ? "col-md-6" : "d-none"
              }
            >
              <div className="form-group">
                <label className="form-label" htmlFor="city">
                  City{" "}
                  {isCrmDataFieldRequired(eventData, "city", editRegistration)
                    ? "*"
                    : ""}
                </label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={editRegistration?.city || ""}
                  onChange={handleChange}
                  className="form-control"
                  required={
                    isCrmDataFieldRequired(eventData, "city", editRegistration)
                      ? true
                      : false
                  }
                />
              </div>
            </div>
            <div
              className={
                eventData?.dataFields?.state?.visible || eventData?.dataFields?.state?.adminOnly
                  ? "col-md-2"
                  : "d-none"
              }
            >
              <div className="form-group">
                <label className="form-label" htmlFor="state">
                  State{" "}
                  {isCrmDataFieldRequired(eventData, "state", editRegistration)
                    ? "*"
                    : ""}
                </label>
                <select
                  name="state"
                  id="state"
                  defaultValue={editRegistration?.state}
                  value={editRegistration?.state}
                  onChange={handleChange}
                  className="form-control"
                  required={
                    isCrmDataFieldRequired(eventData, "state", editRegistration)
                      ? true
                      : false
                  }
                >
                  <option value=""></option>
                  {StatesList?.map((usState, index) => (
                    <option key={"c" + index} value={usState.abbreviation}>
                      {usState.abbreviation}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div
              className={
                eventData?.dataFields?.postal?.visible || eventData?.dataFields?.postal?.adminOnly ? "col-md-4" : "d-none"
              }
            >
              <div className="form-group">
                <label className="form-label" htmlFor="postal">
                  Postal Code{" "}
                  {isCrmDataFieldRequired(eventData, "postal", editRegistration)
                    ? "*"
                    : ""}
                </label>
                <input
                  type="text"
                  id="postal"
                  name="postal"
                  value={editRegistration?.postal || ""}
                  onChange={handlePostal}
                  className="form-control"
                  required={
                    isCrmDataFieldRequired(eventData, "postal", editRegistration)
                      ? true
                      : false
                  }
                />
              </div>
            </div>
          </div>
          {eventData?.additionalFields?.length > 0 && <h2 id="registration-details" className="registration-section-title">Registration details</h2>}
          <div className="row">
            {eventData?.additionalFields?.map((dataField, index) => (
              <Fragment key={dataField.fieldName || index}>
                {dataField.fieldType == "Textblock" ? (
                  <div className="col-12">
                    <AdditionalFieldHtml
                      as="div"
                      className="pb-2"
                      html={dataField?.textCopy}
                    />
                  </div>
                ) : (<></>)}
                {dataField.fieldType == "Textbox" ? (
                  <div className={dataField.fieldFullRow ? "col-md-12" : (dataField.fieldColumns ? "col-md-" + dataField.fieldColumns : "col-md-" + 6) + " " + (dataField.fieldColumnsMobile ? "col-" + dataField.fieldColumnsMobile : "col-" + 12)}>
                    <div className="form-group">
                      <AdditionalFieldLabel
                        className="form-label"
                        field={dataField}
                        htmlFor={dataField.fieldName}
                      />
                      <AdditionalFieldHtml
                        as="div"
                        className="pb-2"
                        html={dataField?.fieldDescription}
                      />
                      <input
                        id={dataField.fieldName}
                        name={dataField.fieldName}
                        value={editRegistration ? editRegistration[dataField.fieldName] : ""}
                        onChange={handleChange}
                        className="form-control"
                        required={
                          dataField.required
                            ? true
                            : false
                        }
                      />
                    </div>
                  </div>) : (<></>)}
                                {dataField.fieldType == "Textarea" ? (
                  <div className={dataField.fieldFullRow ? "col-md-12" : (dataField.fieldColumns ? "col-md-" + dataField.fieldColumns : "col-md-" + 6) + " " + (dataField.fieldColumnsMobile ? "col-" + dataField.fieldColumnsMobile : "col-" + 12)}>
                    <div className="form-group">
                      <AdditionalFieldLabel
                        className="form-label"
                        field={dataField}
                        htmlFor={dataField.fieldName}
                      />
                      <AdditionalFieldHtml
                        as="div"
                        className="pb-2"
                        html={dataField?.fieldDescription}
                      />
                      <textarea
                        id={dataField.fieldName}
                        style={{ minHeight: "100px" }}
                        name={dataField.fieldName}
                        value={editRegistration ? editRegistration[dataField.fieldName] : ""}
                        onChange={handleChange}
                        className="form-control"
                        required={
                          dataField.required
                            ? true
                            : false
                        }
                      />
                    </div>
                  </div>) : (<></>)}
                {/* {dataField.fieldType == "CommerceItem" ? (
                            <div className={dataField.fieldFullRow ? "col-md-12" : "col-md-6"}>
                              <div className="form-group">
                                <label className="form-label" htmlFor={dataField.fieldName}>
                                  {dataField.fieldLabel}{" "}
                                  {dataField.required
                                    ? "*"
                                    : ""} ({dataField.fieldCost})
                                </label>
                                <div className="pb-2">{dataField.fieldDescription}</div>
                                <input
                                  type="number"
                                  id={dataField.fieldName}
                                  name={dataField.fieldName}
                                  min={dataField.fieldMin}
                                  max={dataField.fieldMax}
                                  step="1"
                                  value={editRegistration ? editRegistration[dataField.fieldName] : ""}
                                  onChange={(e) => { handleChangeCommerceItem(e,dataField.fieldCost,dataField.fieldPayment,dataField.fieldTax)}}
                                  className="form-control"
                                  required={
                                    dataField.required
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              {editRegistration && editRegistration[dataField.fieldName] ? (
<div className="py-2">
  <div>Total Due: {editRegistration[dataField.fieldName + "Cost"]} / plus tax</div>
</div>
) : (<></>)}
                            </div>) : (<></>)} */}
                {dataField.fieldType == "CommerceItem" ? (<>
                  <div className={dataField.fieldFullRow ? "col-md-12" : (dataField.fieldColumns ? "col-md-" + dataField.fieldColumns : "col-md-" + 6) + " " + (dataField.fieldColumnsMobile ? "col-" + dataField.fieldColumnsMobile : "col-" + 12)}>                    <div className="form-group">
                    <AdditionalFieldLabel
                      className="form-label"
                      field={dataField}
                      htmlFor={dataField.fieldName}
                    />
                    <AdditionalFieldHtml
                      as="div"
                      className="pb-2"
                      html={dataField?.fieldDescription}
                    />
                    <div className="d-flex align-items-center">
                      {/* <input
                        disabled={editRegistration?.adyenRef || editRegistration?.adyenLink}
                        type="number"
                        id={dataField.fieldName}
                        name={dataField.fieldName}
                        min={dataField.fieldMin}
                        max={dataField.fieldMax}
                        step="1"
                        value={editRegistration ? editRegistration[dataField.fieldName] : ""}
                        onChange={(e) => { handleChangeCommerceItem(e, dataField.fieldCost) }}
                        className="form-control"
                        required={
                          dataField.required
                            ? true
                            : false
                        }
                      />  */}
                      <select
                        disabled={
                          editRegistration?.adyenRef ||
                          editRegistration?.adyenLink ||
                          isCommerceItemSoldOut(dataField) ||
                          ((dataField.fieldCapacity === "eventCapacity" ||
                            dataField.fieldCapacity === "itemCapacity") &&
                            !commerceAvailability.isLoaded)
                        }
                        className="form-control commerce-item"
                        id={dataField.fieldName}
                        name={dataField.fieldName}
                        value={editRegistration ? editRegistration[dataField.fieldName] : ""}
                        onChange={(e) => { handleChangeCommerceItem(e, dataField.fieldCost) }}
                        required={
                          dataField.required
                            ? true
                            : false
                        }
                      >
                        {(() => {
                          let rows = [];
                          const maximum = getCommerceItemMaximum(dataField);
                          for (let i = 0; i <= maximum; i++) {
                            rows.push(<option value={i} key={i}>{i}</option>);
                          }
                          return rows;
                        })()}
                      </select>
                      {isCommerceItemSoldOut(dataField) ? (
                        <span className="bold-font highlight ps-3">
                          SOLD OUT
                        </span>
                      ) : null}
                      {commerceAvailability.error &&
                        (dataField.fieldCapacity === "eventCapacity" ||
                          dataField.fieldCapacity === "itemCapacity") ? (
                          <span className="fs-xs text-danger ps-2">
                            Live availability is unavailable.
                          </span>
                        ) : null}
                      {/* <div className0="ps-3">{editRegistration && editRegistration[dataField.fieldName] ? editRegistration[dataField.fieldName + "Cost"] :""}</div> */}
                    </div>
                  </div>
                  </div>
                  {/* <div id="customCard-container" className={adyenLoaded ? "d-block" : "d-none"}>
                    <div className="col-12">
                      <h3>Payment Details</h3>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <label>Card Number *</label>
                        <div className="form-control" data-cse="encryptedCardNumber"></div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row">
                        <div className="col-md-6 col-12">
                          <div className="form-group">
                            <label>Expiration Date *</label>
                            <div className="form-control" data-cse="encryptedExpiryDate"></div>
                          </div>
                        </div>
                        <div className="col-md-6 col-12">
                          <div className="form-group">
                            <label>CVV/CVC *</label>
                            <div className="form-control" data-cse="encryptedSecurityCode"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </>) : (<></>)}
                {dataField.fieldType == "Numberbox" ? (
                  <div className={dataField.fieldFullRow ? "col-md-12" : (dataField.fieldColumns ? "col-md-" + dataField.fieldColumns : "col-md-" + 6) + " " + (dataField.fieldColumnsMobile ? "col-" + dataField.fieldColumnsMobile : "col-" + 12)}>                    <div className="form-group">
                    <AdditionalFieldLabel
                      className="form-label"
                      field={dataField}
                      htmlFor={dataField.fieldName}
                    />
                    <AdditionalFieldHtml
                      as="div"
                      className="pb-2"
                      html={dataField?.fieldDescription}
                    />
                    <input
                      type="number"
                      id={dataField.fieldName}
                      name={dataField.fieldName}
                      min={dataField.fieldMin}
                      max={dataField.fieldMax}
                      step={dataField.fieldStep}
                      value={editRegistration ? editRegistration[dataField.fieldName] : ""}
                      onChange={handleChange}
                      className="form-control"
                      required={
                        dataField.required
                          ? true
                          : false
                      }
                    />
                  </div>
                  </div>) : (<></>)}
                {dataField.fieldType == "Dropdown" ? (
                  <div className={dataField.fieldFullRow ? "col-md-12" : (dataField.fieldColumns ? "col-md-" + dataField.fieldColumns : "col-md-" + 6) + " " + (dataField.fieldColumnsMobile ? "col-" + dataField.fieldColumnsMobile : "col-" + 12)}>
                    <div className={"form-group"}>
                      <AdditionalFieldLabel
                        className="form-label"
                        field={dataField}
                        htmlFor={dataField.fieldName}
                      />
                      <AdditionalFieldHtml
                        as="div"
                        className="pb-2"
                        html={dataField?.fieldDescription}
                      />
                      <select
                        className="form-control"
                        id={dataField.fieldName}
                        name={dataField.fieldName}
                        value={editRegistration ? editRegistration[dataField.fieldName] : ""}
                        onChange={(e) => {
                          setEditRegistration({
                            ...editRegistration,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        required={
                          dataField.required
                            ? true
                            : false
                        }
                      >
                        <option value=""></option>
                        {dataField?.fieldOptions?.split(';').map((opt, index) => (
                          <option value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>) : (<></>)}
                {dataField.fieldType == "Checkbox" ? (
                  <div className={dataField.fieldFullRow ? "col-md-12" : (dataField.fieldColumns ? "col-md-" + dataField.fieldColumns : "col-md-" + 6) + " " + (dataField.fieldColumnsMobile ? "col-" + dataField.fieldColumnsMobile : "col-" + 12)}>
                    <div className={"form-group"}>
                      <label className="checkbox-container">
                        <AdditionalFieldHtml html={dataField?.fieldLabel} />
                        {dataField.required ? " *" : ""}
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            setEditRegistration({
                              ...editRegistration,
                              [e.target.name]: e.target.checked,
                            });
                          }}
                          id={dataField.fieldName + index}
                          name={dataField.fieldName}
                          checked={editRegistration && editRegistration[dataField.fieldName] ? editRegistration[dataField.fieldName] : ""}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <AdditionalFieldHtml
                        as="div"
                        className="pb-2"
                        html={dataField?.fieldDescription}
                      />
                    </div>
                  </div>) : (<></>)}
                {dataField.fieldType == "DateTime" ? (
                  <div className={dataField.fieldFullRow ? "col-md-12" : (dataField.fieldColumns ? "col-md-" + dataField.fieldColumns : "col-md-" + 6) + " " + (dataField.fieldColumnsMobile ? "col-" + dataField.fieldColumnsMobile : "col-" + 12)}>                                  <div className="row">
                    <div className={"form-group"}>
                      <label className="form-label" htmlFor={dataField.fieldName}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            dataField?.fieldLabel + " " + (dataField?.required ? "*" : "")
                          ),
                        }}>
                      </label>
                      <div className="pb-2"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            dataField?.fieldDescription
                          ),
                        }}
                      >
                      </div>
                      <input
                        className="form-control"
                        type="datetime-local"
                        onChange={(e) => {
                          if (!e.target.checkValidity()) {
                            e.target.classList.add("invalid-input");
                          } else {
                            e.target.classList.remove("invalid-input");
                          }
                          setEditRegistration({
                            ...editRegistration,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        required={dataField.required ? true : false}
                        id={dataField.fieldName + index}
                        name={dataField.fieldName}
                        min={dataField.fieldMin}
                        max={dataField.fieldMax}
                        value={dataField && dataField.fieldName && editRegistration ? editRegistration[dataField.fieldName] : ""}
                      />
                    </div>
                  </div>
                  </div>) : (<></>)}
                {dataField.fieldType == "Date" ? (
                  <div className={dataField.fieldFullRow ? "col-md-12" : (dataField.fieldColumns ? "col-md-" + dataField.fieldColumns : "col-md-" + 6) + " " + (dataField.fieldColumnsMobile ? "col-" + dataField.fieldColumnsMobile : "col-" + 12)}>                                  <div className="row">
                    <div className={"form-group"}>
                      <label className="form-label" htmlFor={dataField.fieldName}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            dataField?.fieldLabel + " " + (dataField?.required ? "*" : "")
                          ),
                        }}>
                      </label>
                      <div className="pb-2"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            dataField?.fieldDescription
                          ),
                        }}
                      >
                      </div>
                      <input
                        className="form-control"
                        type="date"
                        onChange={(e) => {
                          if (!e.target.checkValidity()) {
                            e.target.classList.add("invalid-input");
                          } else {
                            e.target.classList.remove("invalid-input");
                          }
                          setEditRegistration({
                            ...editRegistration,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        required={dataField.required ? true : false}
                        id={dataField.fieldName + index}
                        name={dataField.fieldName}
                        min={dataField.fieldMin}
                        max={dataField.fieldMax}
                        value={dataField && dataField.fieldName && editRegistration ? editRegistration[dataField.fieldName] : ""}
                      />
                    </div>
                  </div>
                  </div>) : (<></>)}
                {dataField.fieldType == "Time" ? (
                  <div className={dataField.fieldFullRow ? "col-md-12" : (dataField.fieldColumns ? "col-md-" + dataField.fieldColumns : "col-md-" + 6) + " " + (dataField.fieldColumnsMobile ? "col-" + dataField.fieldColumnsMobile : "col-" + 12)}>                                  <div className="row">
                    <div className={"form-group"}>
                      <label className="form-label" htmlFor={dataField.fieldName}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            dataField?.fieldLabel + " " + (dataField?.required ? "*" : "")
                          ),
                        }}>
                      </label>
                      <div className="pb-2"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            dataField?.fieldDescription
                          ),
                        }}
                      >
                      </div>
                      <input
                        className="form-control"
                        type="time"
                        onChange={(e) => {
                          if (!e.target.checkValidity()) {
                            e.target.classList.add("invalid-input");
                          } else {
                            e.target.classList.remove("invalid-input");
                          }
                          setEditRegistration({
                            ...editRegistration,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        required={dataField.required ? true : false}
                        id={dataField.fieldName + index}
                        name={dataField.fieldName}
                        min={dataField.fieldMin}
                        max={dataField.fieldMax}
                        value={dataField && dataField.fieldName && editRegistration ? editRegistration[dataField.fieldName] : ""}
                      />
                    </div>
                  </div>
                  </div>) : (<></>)}
                {!dataField.fieldType ? (
                  <div className={dataField.fieldFullRow ? "col-md-12 d-none d-md-flex" : "col-md-6 d-none d-md-flex"}>
                    <div>&nbsp;</div>
                  </div>) : (<></>)}
              </Fragment>
            ))}
          </div>
          {eventData?.allowGuests && eventData?.capacityType == "session" &&
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="guestFirstName">
                    Guest First Name
                  </label>
                  <input
                    type="text"
                    id="guestFirstName"
                    name="guestFirstName"
                    value={editRegistration?.guestFirstName || ""}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="guestLastName">
                    Guest Last Name
                  </label>
                  <input
                    type="text"
                    id="guestLastName"
                    name="guestLastName"
                    value={editRegistration?.guestLastName || ""}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="guestEmail">
                    Guest Email
                  </label>
                  <input
                    type="text"
                    id="guestEmail"
                    name="guestEmail"
                    value={editRegistration?.guestEmail || ""}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label" htmlFor="guestPhone">
                    Guest Phone
                  </label>
                  <input
                    type="text"
                    id="guestPhone"
                    name="guestPhone"
                    value={editRegistration?.guestPhone || ""}
                    onChange={handlePhoneChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          }
          {eventData?.allowPushToCap &&
            <>
              <div className="row align-items-center">
                <div className="col-md-12">
                  <div className={"form-group"}>
                    <label className="form-label" htmlFor="description">
                      Would you like to be contacted by your local Porsche Center?{" "}
                      {shouldAskDealerOptIn(eventData, editRegistration) ? "*" : ""}
                    </label>
                    <select
                      className="form-control"
                      id="dealer_optin"
                      name="dealer_optin"
                      onChange={(e) => {
                        setEditRegistration({
                          ...editRegistration,
                          dealer_optin: e.target.value === "true" ? true : (e.target.value === "false" ? false : null),
                        });
                      }}
                      value={editRegistration?.dealer_optin}
                      required={shouldAskDealerOptIn(eventData, editRegistration)}
                    >
                      <option value=""></option>
                      <option value="true">
                        Yes
                      </option>
                      <option value="false">
                        No
                      </option>
                    </select>
                  </div>
                  {/* <div className="row py-4">
                      <div className="col-auto">
                        <div className="form-group">
                          <label className="checkbox-container mb-0">
                            <input
                              type="checkbox"
                              onChange={(e) => {
                                setEditRegistration({
                                  ...editRegistration,
                                  [e.target.name]: e.target.checked,
                                });
                              }}
                              id="dealer_optin"
                              name="dealer_optin"
                              checked={editRegistration?.dealer_optin || false}
                              value={editRegistration?.dealer_optin || false}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div>
                      <div className="col"></div>
                    </div> */}
                </div>
              </div>
              <div className="row">
                {(eventData?.dataFields?.purchaseTimeFrame?.visible || eventData?.dataFields?.purchaseTimeFrame?.adminOnly || eventData?.skipDealerOptIn) &&
                  <div
                    className="col-md-12"
                  >
                    <div className={"form-group"}>
                      <label className="form-label" htmlFor="description">
                        {eventData?.skipDealerOptIn ? "If you are considering purchasing a new vehicle, what is your timeframe?" : "Purchase Timeframe"}{" "}
                        {editRegistration?.dealer_optin || (eventData?.skipDealerOptIn && !eventData?.skipPurchaseTimeFrame)
                          ? "*"
                          : ""}
                      </label>
                      <select
                        className="form-control"
                        id="purchaseTimeFrame"
                        name="purchaseTimeFrame"
                        onChange={(e) => {
                          setEditRegistration({
                            ...editRegistration,
                            purchaseTimeFrame: e.target.value,
                          });
                        }}
                        value={editRegistration?.purchaseTimeFrame}
                        required={
                          editRegistration?.dealer_optin || (eventData?.skipDealerOptIn && !eventData?.skipPurchaseTimeFrame)
                            ? true
                            : false
                        }
                      >
                        <option value=""></option>
                        <option value="id_ao1_timeframe">
                          0 - 3 months
                        </option>
                        <option value="id_ao2_timeframe">
                          3 - 6 months
                        </option>
                        <option value="id_ao3_timeframe">
                          6 - 9 months
                        </option>
                        <option value="id_ao4_timeframe">
                          9 - 12 months
                        </option>
                        <option value="id_ao5_timeframe">
                          12 months+
                        </option>
                        <option value="--">Not sure</option>
                      </select>
                    </div>
                  </div>
                }
                {(eventData?.dataFields?.modelInterest?.visible || eventData?.dataFields?.modelInterest?.adminOnly || eventData?.skipDealerOptIn) &&
                  <div
                    className="col-md-12"
                  >
                    <div className={"form-group"}>
                      <label className="form-label" htmlFor="modelInterest">
                        Model Interest{" "}
                        {editRegistration?.dealer_optin || (eventData?.skipDealerOptIn && !eventData?.skipModelInterest)
                          ? "*"
                          : ""}
                      </label>
                      <select
                        className="form-control"
                        id="modelInterest"
                        name="modelInterest"
                        onChange={(e) => {
                          setEditRegistration({
                            ...editRegistration,
                            modelInterest: e.target.value,
                          });
                        }}
                        value={editRegistration?.modelInterest}
                        required={
                          editRegistration?.dealer_optin || (eventData?.skipDealerOptIn && !eventData?.skipModelInterest)
                            ? true
                            : false
                        }
                      >
                        <option value=""></option>
                        {getVisibleModelInterestOptions(
                          eventData?.modelsSelected,
                          editRegistration?.modelInterest,
                          modelInterestCatalog,
                        ).map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                        <option value="--">Not Sure</option>
                      </select>
                    </div>
                  </div>
                }
                {(eventData?.dataFields?.experience?.visible || eventData?.dataFields?.experience?.adminOnly || eventData?.skipDealerOptIn) &&
                  <div className="col-md-12">
                    <div className={"form-group"}>
                      <label className="form-label" htmlFor="experience">
                        Experience with Porsche{" "}
                        {isCrmDataFieldRequired(eventData, "experience", editRegistration)
                          ? "*"
                          : ""}
                      </label>
                      <select
                        className="form-control"
                        id="experience"
                        name="experience"
                        onChange={(e) => {
                          setEditRegistration({
                            ...editRegistration,
                            experience: e.target.value,
                          });
                        }}
                        value={editRegistration?.experience}
                        required={
                          isCrmDataFieldRequired(eventData, "experience", editRegistration)
                            ? true
                            : false
                        }
                      >
                        <option value=""></option>
                        <option value="A1">
                          I’ve never driven a Porsche, and not familiar with the Brand
                        </option>
                        <option value="A2">
                          I’ve never driven a Porsche, but I’m familiar with the Brand
                        </option>
                        <option value="A3">
                          I’ve driven a Porsche, but never owned a Porsche
                        </option>
                        <option value="A4">
                          I’ve owned a Porsche, but do not currently own
                        </option>
                        <option value="A5">I currently own a Porsche</option>
                      </select>
                    </div>
                  </div>
                }
              </div>
            </>
          }

          <div className="row">

            {(eventData?.dataFields?.dealer?.visible || eventData?.dataFields?.dealer?.adminOnly) &&
              <div className="col-md-12">
                {dealersSelected && dealersSelected.length > 1 &&
                  <div className={"form-group"}>
                    <label className="form-label" htmlFor="dealer">
                      Preferred Porsche Center{" "}
                      {isCrmDataFieldRequired(eventData, "dealer", editRegistration)
                        ? "*"
                        : ""}
                    </label>
                    <Select
                      classNamePrefix="manage-select"
                      id="dealer"
                      name="dealer"
                      value={dealersSelected.find(o => o.value === editRegistration?.dealer)}
                      onChange={(e) => {
                        console.log(e);
                        console.log(editRegistration.dealer);
                        setEditRegistration({
                          ...editRegistration,
                          dealer: e.value,
                        });
                      }}
                      options={dealersSelected}
                      filterOption={filterDealerOption}
                      placeholder="Search Porsche Center, city, state or postal code"
                      inputId="dealer-search"
                      aria-label="Preferred Porsche Center"
                      required={
                        isCrmDataFieldRequired(eventData, "dealer", editRegistration)
                          ? true
                          : false
                      }
                    />
                  </div>
                }
                {dealersSelected && dealersSelected.length == 1 &&
                  <div className={"form-group"}>
                    <label className="form-label" htmlFor="dealer">
                      Preferred Dealer
                    </label>
                    <div className="">{dealersSelected[0].name}</div>
                  </div>
                }
              </div>
            }
          </div>

          <div className="row">
            <div className="col-md-12">
              {editRegistration?.totalCost ? (
                <div className="pb-4">
                  <hr />
                  <h4 className="bold-font">Checkout Summary</h4>
                  <div className="row pb-4">
                    <div className="col-md-8 col-6"></div>
                    <div className="col-md-2 col-3">Qty</div>
                    <div className="col-md-2 col-3">Cost</div>
                  </div>
                  {eventData?.additionalFields?.map((item, index) => (
                    <Fragment key={"d" + index}>
                      {editRegistration[item.fieldName] && editRegistration[item.fieldName] > 0 ? (
                        <div className="row">
                          <div className="col-md-8 col-6">
                            <AdditionalFieldHtml html={item.fieldLabel} />
                          </div>
                          <div className="col-md-2 col-3">{editRegistration[item.fieldName]}</div>
                          <div className="col-md-2 col-3">{editRegistration[item.fieldName + "Cost"]}</div>
                        </div>
                      ) : (<></>)}
                    </Fragment>
                  ))}
                  <hr />
                  {eventData?.paymentTax > 0 ? <div>
                    <div className="row">
                      <div className="col-md-8 col-6"></div>
                      <div className="col-md-2 col-3 bold-font text-end">Subtotal:</div>
                      <div className="col-md-2 col-3">{editRegistration?.subCost}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-8 col-6"></div>
                      <div className="col-md-2 col-3 bold-font text-end">Tax({eventData?.fieldTax}%):</div>
                      <div className="col-md-2 col-3">{editRegistration?.taxCost}</div>
                    </div>
                  </div> : <></>}
                  <div className="row">
                    <div className="col-md-8 col-6"></div>
                    <div className="col-md-2 col-3 bold-font text-end">Total:</div>
                    <div className="col-md-2 col-3">{editRegistration?.totalCost}</div>
                  </div>
                </div>) : (<></>)}
            </div>
            {eventData?.paymentType === '' ? <div className="col-12">
              <div className="alert alert-warning">Payment for this registration will be handled manually.</div>
            </div> : <div className="col-12"></div>}
          </div>
          <h2 id={!eventData?.additionalFields?.length ? "registration-details" : undefined} className="registration-section-title">Status and payment</h2>
          <div className="row">
            <div className="col-md-6">
              <div className={"form-group"}>
                <label className="form-label" htmlFor="status">
                  Status *
                </label>
                <select
                  className="form-control"
                  id="status"
                  name="status"
                  onChange={(e) => {
                    setEditRegistration({
                      ...editRegistration,
                      ...getRegistrationStatusUpdate(e.target.value),
                    });
                  }}
                  value={getRegistrationStatusSelectValue(editRegistration)}
                  required={true}
                >
                  <option value="Pending">Pending</option>
                  <option value="Registered">Registered</option>
                  <option value="Confirmed">Confirmed</option>
                  {eventData?.allowCheckedOut &&
                    <option value="Checked-Out">Checked-Out</option>
                    }
                  <option value="Checked-In">Checked-In</option>
                  <option value="Completed">Completed</option>
                  <option value="Waitlist">Waitlist</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Self-Cancelled">Self-Cancelled</option>
                  <option value="No Show-Cancelled">No Show-Cancelled</option>
                </select>
              </div>
              {/* {editRegistration?.status == "Checked-In" &&
                <div className="alert alert-danger fs-lg">Guest Checked-in</div>
              } */}
            </div>            <div className="col-md-6">
              {eventData?.additionalFields && eventData?.additionalFields.length > 0 && arraySearch(eventData?.additionalFields, 'CommerceItem') >= 0 ?
                <div className={"form-group"}>
                  <label className="form-label" htmlFor="adyenPaymentStatus">
                    Payment Status *
                  </label>
                  <select disabled={true}
                    className="form-control"
                    id="adyenPaymentStatus"
                    name="adyenPaymentStatus"
                    onChange={(e) => {
                      setEditRegistration({
                        ...editRegistration,
                        adyenPaymentStatus: e.target.value,
                      });
                    }}
                    value={editRegistration?.adyenPaymentStatus}
                    required={true}
                  >
                    <option value="Pending">Pending</option>
                    <option value="Paid">Paid</option>
                    <option value="Waived">Waived</option>
                    <option value="Refunded">Refunded</option>
                  </select>
                </div>
                : <></>}
              {editRegistration?.adyenResultCode &&
                <div><label>Adyen Result:</label> {editRegistration?.adyenResultCode}</div>
              }
              {editRegistration?.adyenRef &&
                <div><label>Adyen Ref #:</label> {editRegistration?.adyenRef}</div>
              }
              {editRegistration?.adyenRefDate &&
                <div><label>Adyen Ref Date:</label> {moment(editRegistration?.adyenRefDate).format("MM/DD/YYYY h:mm A")}</div>
              }
              {editRegistration?.adyenLink && !editRegistration?.adyenRef &&
                <div><label>Adyen Link:</label> <a href={editRegistration?.adyenLink} target="_blank">{editRegistration?.adyenLink}</a></div>
              }
              {editRegistration?.adyenLinkExpireDate && !editRegistration?.adyenRef &&
                <div><label>Adyen Link Expiration:</label> {moment(editRegistration?.adyenLinkExpireDate).format("MM/DD/YYYY h:mm A")}</div>
              }
              {editRegistration?.adyenLinkId &&
                <div><label>Adyen Link Id:</label> {editRegistration?.adyenLinkId}</div>
              }
              {editRegistration?.adyenLink && !editRegistration?.adyenRef &&
                <div>  <button className="btn btn-theme" onClick={handleDeletePaymentLink}>
                  Delete Payment Link
                </button></div>
              }
              {eventData?.additionalFields && eventData?.additionalFields.length > 0 && arraySearch(eventData?.additionalFields, 'CommerceItem') >= 0 && !editRegistration?.adyenLink && !editRegistration?.adyenRef && (!editRegistration?.adyenPaymentStatus || editRegistration?.adyenPaymentStatus === "Pending") &&
                <div className="pb-2"><button className="btn btn-theme" onClick={handleCreatePaymentLink}>
                  Create Payment Link
                </button></div>
              }
              {eventData?.additionalFields && eventData?.additionalFields.length > 0 && arraySearch(eventData?.additionalFields, 'CommerceItem') >= 0 && !editRegistration?.adyenLink && !editRegistration?.adyenRef && editRegistration?.adyenPaymentStatus !== "Waived" &&
                <div>  <button className="btn btn-theme" onClick={handleWaivedPaymentLink}>
                  Waive Payment
                </button></div>
              }
              {editRegistration?.adyenRef && editRegistration?.adyenPaymentStatus === "Paid" &&
                <div>  <button className="btn btn-default" onClick={handleRefundedPaymentLink}>
                  Mark Refunded
                </button></div>
              }
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <label className="form-label">Registration Flags</label>
                <div className="registration-flags">
                  <label className="checkbox-container">
                    Confirmed
                    <input
                      type="checkbox"
                      id="isConfirmed"
                      name="isConfirmed"
                      checked={!!editRegistration?.isConfirmed}
                      onChange={(e) => {
                        handleRegistrationFlagChange("isConfirmed", e.target.checked);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="checkbox-container">
                    No Show-Cancelled
                    <input
                      type="checkbox"
                      id="isNoShow"
                      name="isNoShow"
                      checked={!!editRegistration?.isNoShow}
                      onChange={(e) => {
                        handleRegistrationFlagChange("isNoShow", e.target.checked);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div><label>Created: </label>{editRegistration?.createdAt ? moment(editRegistration?.createdAt).format("MM/DD/YYYY h:mm A") : "N/A"}</div>
              <div><label>Updated: </label>{editRegistration?.updatedAt ? moment(editRegistration?.updatedAt).format("MM/DD/YYYY h:mm A") : "N/A"}</div>
              <div><label>Expiration: </label>{editRegistration?.expiration ? moment(editRegistration?.expiration).format("MM/DD/YYYY h:mm A") : "N/A"}</div>
                           {editRegistration?.passcode &&
                <div><label>PASSCDDE:</label> {editRegistration?.passcode}</div>
              }
              {editRegistration?.bpid &&
                <div><label>BPID:</label> {editRegistration?.bpid}</div>
              }
            
 
              {editRegistration?.vin &&
                <div><label>VIN:</label> {editRegistration?.vin}</div>
              }
            </div>
          </div>
        </div>
      </div>
      <div className={eventData?.allowWaivers ? "waivers" : "waivers d-none"}>
        <div
          className={
            completeWaiver || (editRegistration && editRegistration.hasWaiver)
              ? "d-none"
              : ""
          }
        >
          <button
            className="btn btn-primary"
            onClick={() => {
              setCompleteWaiver(true);
            }}
          >
            Complete Waiver
          </button>
          <button disabled={disabledSend} className="btn btn-default ml-3" onClick={() => { setDisabledSend(true); sendWaiver() }}>
            Send Waiver Email
          </button>
          <button disabled={disabledSend} className="btn btn-default ml-3" onClick={() => { setDisabledSend(true); sendWaiverSMS() }}>
            Send Waiver SMS
          </button>
        </div>
        <div
          className={
            editRegistration && !editRegistration.hasWaiver ? "d-none" : ""
          }
        >
          <a
            className="btn btn-default"
            onClick={(e) => {
              downloadWaiver(e, waiverUrl);
            }}
            href={waiverUrl}
          >
            Download Waiver
          </a>
          <button className="btn btn-default ml-3" onClick={deleteWaiver}>
            Delete Waiver
          </button>
        </div>
        <div
          className={
            completeWaiver && editRegistration && !editRegistration.hasWaiver
              ? "waiver-form"
              : "d-none"
          }
        >
          <h5>Complete Waiver</h5>
          <div
            id="waiver-print"
            className="hidden"
            style={{
              fontSize: "12px !important",
              fontFamily: "Arial !important",
              maxWidth: "560px !important",
            }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(eventData?.waiverCopy?.content),
              }}
            ></div>
            <div>Signature:</div>
            <div style={{ borderBottom: "2px solid #000000" }}>
              <img src={waiverSigUrl} alt="Waiver Signature" />
            </div>
            <div style={{ borderBottom: "2px solid #000000,padding-top:40px" }}>
              Printed Name: {editRegistration?.firstName}{" "}
              {editRegistration?.lastName}
            </div>
            <div style={{ borderBottom: "2px solid #000000,paddingTop:40px" }}>
              Date: {moment().format("MM/DD/YYYY")}
            </div>
            <div className="text-center">
              <div></div>
            </div>
          </div>
          <div
            className="py-3"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(eventData?.waiverCopy?.content),
            }}
          ></div>
          <div>Signature</div>
          <div className="sig-container">
            <SignatureCanvas
              ref={sigCanvas}
              onBegin={() => { setSavingSignature(true) }}
              onEnd={saveCanvas}
              canvasProps={{
                width: scr.width,
                height: scr.height,
                className: "sigCanvas",
              }}
            />
          </div>
          <div className="">
            <button className="btn btn-default" onClick={clearCanvas}>
              Clear Signature
            </button>
            <button
              className="btn btn-default ml-3"
              onClick={() => {
                setCompleteWaiver(false);
                sigCanvas.current.clear();
              }}
            >
              Cancel Waiver
            </button>
          </div>
        </div>
      </div>
      <div className={eventData?.allowGuestWaivers && (editRegistration?.guestFirstName || editRegistration?.guestLastName) ? "waivers" : "waivers d-none"}>
        <div
          className={
            completeGuestWaiver || (editRegistration && editRegistration.hasGuestWaiver)
              ? "d-none"
              : ""
          }
        >
          <button
            className="btn btn-primary"
            onClick={() => {
              setCompleteGuestWaiver(true);
            }}
          >
            Complete Guest Waiver
          </button>
          <button disabled={disabledSend} className="btn btn-default ml-3" onClick={() => { setDisabledSend(true); sendGuestWaiver() }}>
            Send Guest Waiver Email
          </button>
          <button disabled={disabledSend} className="btn btn-default ml-3" onClick={() => { setDisabledSend(true); sendGuestWaiverSMS() }}>
            Send Guest Waiver SMS
          </button>
        </div>
        <div
          className={
            editRegistration && !editRegistration.hasGuestWaiver ? "d-none" : ""
          }
        >
          <a
            className="btn btn-default"
            onClick={(e) => {
              downloadGuestWaiver(e, waiverGuestUrl);
            }}
            href={waiverGuestUrl}
          >
            Download Guest Waiver
          </a>
          <button className="btn btn-default ml-3" onClick={deleteGuestWaiver}>
            Delete Guest Waiver
          </button>
        </div>
        <div
          className={
            completeGuestWaiver && editRegistration && !editRegistration.hasGuestWaiver
              ? "waiver-form"
              : "d-none"
          }
        >
          <h5>Complete Guest Waiver</h5>
          <div
            id="waiver-guest-print"
            className="hidden"
            style={{
              fontSize: "12px !important",
              fontFamily: "Arial !important",
              maxWidth: "560px !important",
            }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(eventData?.waiverCopy?.content),
              }}
            ></div>
            <div>Signature:</div>
            <div style={{ borderBottom: "2px solid #000000" }}>
              <img src={waiverGuestSigUrl} alt="Waiver Guest Signature" />
            </div>
            <div style={{ borderBottom: "2px solid #000000,padding-top:40px" }}>
              Printed Guest Name: {editRegistration?.guestFirstName}{" "}
              {editRegistration?.guestLastName}
            </div>
            <div style={{ borderBottom: "2px solid #000000,paddingTop:40px" }}>
              Date: {moment().format("MM/DD/YYYY")}
            </div>
            <div className="text-center">
              <div></div>
            </div>
          </div>
          <div
            className="py-3"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(eventData?.waiverCopy?.content),
            }}
          ></div>
          <div>Guest Signature</div>
          <div className="sig-container">
            <SignatureCanvas
              ref={sigGuestCanvas}
              onBegin={() => { setSavingSignature(true) }}
              onEnd={saveGuestCanvas}
              canvasProps={{
                width: scr.width,
                height: scr.height,
                className: "sigCanvas",
              }}
            />
          </div>
          <div className="">
            <button className="btn btn-default" onClick={clearGuestCanvas}>
              Clear Guest Signature
            </button>
            <button
              className="btn btn-default ml-3"
              onClick={() => {
                setCompleteGuestWaiver(false);
                sigGuestCanvas.current.clear();
              }}
            >
              Cancel Guest Waiver
            </button>
          </div>
        </div>
      </div>
      <div>
        {uploadInfo &&
          <div className="py-5">
            <div><strong>Submission Details</strong></div>
            <div>Total Files: {uploadInfo.length}</div>
            {uploadInfo?.map((f, index) => (
              <div className="row hover-row py-2" key={"d" + index}>
                <div className="col"><a href={f.url} target="_blank">{f.name}</a></div>
                <div className="col-auto"><i className="sm" onClick={() => {
                  var fileRef = firebase.storage().refFromURL(f.url);
                  fileRef.delete().then(function () {
                    // File deleted successfully
                    updateUploads();
                  }).catch(function (error) {
                    // Some Error occurred
                  });
                }}>
                  <DeleteIcon />
                </i></div>
              </div>
            ))}
            <div className="py-2"></div>
          </div>
        }
        {eventData?.allowUpload &&
          <div className="pt-0">
            <div className="pb-3">{eventData?.uploadCopy}</div>
            <Dropzone onDrop={onDrop} accept="application/pdf,image/*" maxFiles={eventData?.uploadMaxFiles ? eventData?.uploadMaxFiles : 5} maxSize={26214400}>
              {({ getRootProps, getInputProps, acceptedFiles }) => {
                return (
                  <div className="">
                    {/* <aside>
                                        <h6 className="bold-font py-3">Accepted Files</h6>
                                        {!fileUpload || fileUpload?.length == 0 &&
                                          <div>No files uploaded yet.</div>
                                        }
                                        <ul className="accepted-files">
                                          {fileUpload?.map((file,i) => (
                                            <li key={i} onClick={() => {
                                              let files = fileUpload;
                                              files.splice(i, 1);
                                              setFileUpload([...files]);
                                            }} >
                                             <div className="row"><div className="col-10 col-md-6 col-lg-4">{file.path} - {file.size} bytes</div><div className="col-2 col-md-6 col-lg-8"><DeleteIcon /></div>
                                             </div>
                                            </li>
                                          ))}
                                        </ul>
                                      </aside> */}
                    <div {...getRootProps({ className: 'dropzone' })}>
                      <input {...getInputProps()} />
                      <p>Drag 'n' drop submission files here, or click to select files</p>
                    </div>
                  </div>
                );
              }}
            </Dropzone>
          </div>
        }
      </div>
      {editRegistration?.status === "Registered" && (
        <div>
          <div className="pt-5 pb-2"></div>
          <div className="row">
            <div className="col-auto">
              <button className="btn btn-theme" onClick={handleCheckInAndClose}>
                Check-In & Close
              </button>
            </div>
            <div className="col text-end">&nbsp;</div>
            <div className="col-auto">
              <button className="btn btn-theme" onClick={handleCheckInAndNew}>
                Check-In & New
              </button>
            </div>
            {eventData?.allowGuests && !editRegistration?.isGuest && eventData?.capacityType !== "session" &&
              <div className="col-auto">
                <button className="btn btn-theme" onClick={handleCheckInAndGuest}>
                  Check-In & Add Guest
                </button>
              </div>
            }
            <div className="col text-end">&nbsp;</div>
          </div>
          <div className="pt-5 pb-2"></div>
        </div>
      )}
      <div>
        {(eventData?.allowConfirmationEmail || eventData?.reminderEmail) && (<>
          <div className="pb-3">
            {previewEmailHtml &&
              <button className="btn btn-default" onClick={() => { setPreviewEmailHtml(null); }}>
                Hide Email Preview
              </button>}
            {!previewEmailHtml &&
              <button className="btn btn-default" onClick={previewEmail}>
                Preview Email
              </button>
            }
            <div className={previewEmailHtml ? "py-5" : "d-none"}>
              <iframe title="Confirmation email preview" className="previewEmail" srcDoc={previewEmailHtml} sandbox="allow-same-origin" id="htmlPreviewFrame" name="htmlPreviewFrame" />
            </div>
          </div>
        </>)}
        {eventData?.allowConfirmationEmail && (<>
          <div>
            <label className="checkbox-container">
              Send{editRegistration?.status ? " " + editRegistration?.status : ""}  Confirmation Email
              <input
                type="checkbox"
                onChange={(e) => {
                  setSendEmailCheck(e.target.checked);
                }}
                id="sendEmailCheck"
                name="sendEmailCheck"
                checked={sendEmailCheck}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </>)}
      </div>
      <div>
        {eventData?.reminderEmail && (
          <label className="checkbox-container">
            Send Reminder Email
            <input
              type="checkbox"
              onChange={(e) => {
                setSendEmailCheck(e.target.checked);
              }}
              id="sendEmailCheck"
              name="sendEmailCheck"
              checked={sendEmailCheck}
            />
            <span className="checkmark"></span>
          </label>
        )}
      </div>
      {savingSignature &&
        <div className="alert alert-danger">Waiver is being saved...</div>
      }
      {!savingSignature &&
        <div className="row registration-save-toolbar" aria-label="Registration actions">
          <div className="col-auto">
            <button className="btn btn-theme" disabled={savingRegistration} onClick={handleSubmitNone}>
              {savingRegistration ? "Saving…" : "Save registration"}
            </button>
          </div>
          <div className="col-auto">
            <button className="btn btn-default" disabled={savingRegistration} onClick={handleSubmitAndClose}>
              Save & Close
            </button>
          </div>
          <div className="col-auto">
            <button className="btn btn-default" disabled={savingRegistration} onClick={handleSubmitAndNew}>
              Save & New
            </button>
          </div>
          {eventData?.allowGuests && !editRegistration?.isGuest && eventData?.capacityType !== "session" &&
            <div className="col-auto">
              <button className="btn btn-default" disabled={savingRegistration} onClick={handleSubmitAndGuest}>
                Save & Add Guest
              </button>
            </div>
          }
          <div className="col-auto">
            <button
              className="btn btn-default"
              onClick={() => history("/manage/registrations/" + eventData?.id)}
            >
              Close
            </button>
          </div>
          <div className="col text-end">
            <button
              className="btn btn-link"
              aria-label="Delete registration"
              title="Delete registration"
              onClick={() =>
                window.confirm("Are you sure to delete this record?")
                  ? deleteRegistration()
                  : console.log("action cancelled by user.")
              }
            >
              <i className="sm theme">
                <DeleteIcon />
              </i>
            </button>
          </div>
        </div>
      }
      <div className={"form-group pt-5"}>
        <label className="checkbox-container">
          Do not send lead data.
          <input
            disabled={editRegistration?.leadSent}
            type="checkbox"
            onChange={(e) => {
              if(window.confirm("Are you sure you want to not send lead data?"))
                  {
                    setEditRegistration({
                      ...editRegistration,
                      disableLead: e.target.checked,
                    });
                  
                  } else {
                    console.log("action cancelled by user.")
                  }
                  


              
            }}
            id="disableLead"
            name="disableLead"
            checked={editRegistration?.disableLead || false}
          />
          <span className="checkmark"></span>
        </label>
      </div>
      <div className={eventData?.allowSMSReminders ? "form-group" : "form-group pb-3"}>
        <label className="checkbox-container">
          Data sent to C@P
          <input
            disabled={user?.role > 1 || !editRegistration?.leadSent ? true : false}
            type="checkbox"
            onChange={(e) => {
              setEditRegistration({
                ...editRegistration,
                leadSent: e.target.checked,
              });
            }}
            id="leadSent"
            name="leadSent"
            checked={editRegistration?.leadSent || false}
          />
          <span className="checkmark"></span>
        </label>
      </div>
      {eventData?.allowSMSReminders &&
        <div className={"form-group pb-3"}>
          <label className="checkbox-container">
            SMS Reminder Sent
            <input
              disabled={editRegistration?.smsReminderSent ? false : true}
              type="checkbox"
              onChange={(e) => {
                setEditRegistration({
                  ...editRegistration,
                  smsReminderSent: e.target.checked,
                });
              }}
              id="smsReminderSent"
              name="smsReminderSent"
              checked={editRegistration?.smsReminderSent || false}
            />
            <span className="checkmark"></span>
          </label>
        </div>
      }
      <RegistrationNotes key={"notes-" + editRegistration?.id} registrationId={editRegistration?.id} saved={activitySavedId === editRegistration?.id}
        onLegacyChange={(notes) => setEditRegistration((registration) => ({ ...registration, notes }))} />
      <RegistrationEmailHistory key={"emails-" + editRegistration?.id} registrationId={editRegistration?.id} saved={activitySavedId === editRegistration?.id} refreshKey={activityRefreshKey} />
      <div className="py-3"></div>
    </div>
  );
};
export default Registration;
